// Pages géolocalisées pour trajets spécifiques : Commune ↔ Aéroport / Nantes / Haluchère
// Ces pages ciblent les recherches de trajets précis pour maximiser le SEO
import { allAirportTransfers, getAirportTransferBySlug } from '../utils/airportTransfer';


export const geoRoutePages = {
  // ===============================================
  // TRAJETS VERS L'AÉROPORT NANTES ATLANTIQUE
  // ===============================================
  airport: [
    {
      slug: 'vtc-saint-nazaire-aeroport',
      from: 'Saint-Nazaire',
      to: 'Aéroport Nantes Atlantique',
      title: 'VTC Saint-Nazaire Aéroport - Chauffeur Privé | Réservation Goloire-Cab au 02 59 22 20 00',
      metaDescription: 'Transfert VTC Saint-Nazaire ↔ Aéroport Nantes Atlantique ⚡ Service premium 24h/24 🚗 Tesla & Kia EV6 ✓ Prix fixe 130€ ✓ Suivi des vols ✓ Réservez maintenant !',
      keywords: 'vtc saint nazaire aeroport, transfert saint nazaire aeroport nantes, navette saint nazaire aeroport, taxi saint nazaire aeroport',
      heroImage: 'https://images.unsplash.com/photo-1436491865332-7a61a109cc05?w=1920&q=80&fm=webp',
      distance: '55 km',
      duration: '45 min',
      price: 'dès 130€',
      priceReturn: 'dès 245€',
      fromCoords: { lat: 47.2730, lng: -2.2137 },
      toCoords: { lat: 47.1531, lng: -1.6108 },
      highlights: [
        'Prise en charge à domicile ou hôtel',
        'Suivi des vols en temps réel',
        'Attente gratuite (retard avion)',
        'Aide aux bagages incluse',
        'Véhicules spacieux (grands bagages)',
        'Service 24h/24, 7j/7'
      ],
      description: `Service de transfert VTC premium entre Saint-Nazaire et l'Aéroport Nantes Atlantique. Goloire-Cab assure vos déplacements avec ponctualité et confort. Nos chauffeurs professionnels suivent votre vol en temps réel et s'adaptent aux éventuels retards sans frais supplémentaires. Idéal pour vos voyages d'affaires ou vacances, profitez d'un trajet serein en véhicule électrique haut de gamme.`,
      faq: [
        {
          question: 'Combien coûte un VTC Saint-Nazaire Aéroport ?',
          answer: 'Le transfert VTC Saint-Nazaire vers l\'Aéroport Nantes Atlantique est à 130€ en tarif fixe. Ce prix inclut la prise en charge à domicile, l\'aide aux bagages et le suivi de vol.'
        },
        {
          question: 'Combien de temps dure le trajet Saint-Nazaire Aéroport ?',
          answer: 'Le trajet dure environ 45 minutes en conditions normales de circulation via l\'A11/N165.'
        },
        {
          question: 'Que se passe-t-il si mon vol est en retard ?',
          answer: 'Nous suivons votre vol en temps réel. En cas de retard, votre chauffeur ajuste son arrivée sans frais supplémentaires.'
        }
      ]
    },
    {
      slug: 'vtc-la-baule-aeroport',
      from: 'La Baule',
      to: 'Aéroport Nantes Atlantique',
      title: 'VTC La Baule Aéroport - Chauffeur Privé | Réservation Goloire-Cab au 02 59 22 20 00',
      metaDescription: 'Transfert VTC La Baule ↔ Aéroport Nantes Atlantique ⭐ Service haut de gamme 🚗 Tesla premium ✓ Prix fixe 130€ ✓ Disponible 24/7 ✓ Réservation simple !',
      keywords: 'vtc la baule aeroport, transfert la baule aeroport nantes, navette la baule aeroport, taxi la baule aeroport',
      heroImage: 'https://images.unsplash.com/photo-1436491865332-7a61a109cc05?w=1920&q=80&fm=webp',
      distance: '80 km',
      duration: '1h00',
      price: 'dès 130€',
      priceReturn: 'dès 245€',
      fromCoords: { lat: 47.2861, lng: -2.3933 },
      toCoords: { lat: 47.1531, lng: -1.6108 },
      highlights: [
        'Service luxe adapté à La Baule',
        'Véhicules Tesla Model 3 & Kia EV6',
        'Prise en charge hôtels & villas',
        'Suivi de vol inclus',
        'Bagages volumineux acceptés',
        'Chauffeurs bilingues disponibles'
      ],
      description: `Transfert VTC premium entre La Baule et l'Aéroport Nantes Atlantique. Profitez d'un service haut de gamme adapté à la clientèle exigeante de La Baule. Nos véhicules électriques Tesla offrent un confort optimal pour rejoindre l'aéroport en toute sérénité. Service idéal pour les vacanciers, résidents secondaires et voyageurs d'affaires.`,
      faq: [
        {
          question: 'Quel est le prix du VTC La Baule Aéroport ?',
          answer: 'Le transfert La Baule vers l\'Aéroport Nantes Atlantique coûte 130€ en tarif fixe tout compris.'
        },
        {
          question: 'Pouvez-vous prendre en charge plusieurs passagers ?',
          answer: 'Oui, nos véhicules accueillent jusqu\'à 4 passagers avec leurs bagages. Pour les groupes plus importants, contactez-nous.'
        }
      ]
    },
    {
      slug: 'vtc-pornic-aeroport',
      from: 'Pornic',
      to: 'Aéroport Nantes Atlantique',
      title: 'VTC Pornic Aéroport - Chauffeur Privé | Réservation Goloire-Cab au 02 59 22 20 00',
      metaDescription: 'Transfert VTC Pornic ↔ Aéroport Nantes Atlantique ⚡ Chauffeur privé 24/7 🚗 Prix fixe 110€ ✓ Véhicules électriques ✓ Réservation en ligne !',
      keywords: 'vtc pornic aeroport, transfert pornic aeroport nantes, navette pornic aeroport, taxi pornic aeroport',
      heroImage: 'https://images.unsplash.com/photo-1436491865332-7a61a109cc05?w=1920&q=80&fm=webp',
      distance: '50 km',
      duration: '45 min',
      price: 'dès 110€',
      priceReturn: 'dès 210€',
      fromCoords: { lat: 47.1167, lng: -2.1000 },
      toCoords: { lat: 47.1531, lng: -1.6108 },
      highlights: [
        'Liaison directe Pornic-Aéroport',
        'Prise en charge centre-ville & plages',
        'Suivi des vols en direct',
        'Bagages inclus',
        'Service toute l\'année',
        'Tarif fixe garanti'
      ],
      description: `Service VTC Pornic vers l'Aéroport Nantes Atlantique. Goloire-Cab assure vos transferts aéroport depuis Pornic et ses environs. Parfait pour les résidents et touristes de la côte de Jade, notre service garantit ponctualité et confort pour tous vos vols.`,
      faq: [
        {
          question: 'Combien coûte le transfert Pornic Aéroport ?',
          answer: 'Le tarif fixe pour un transfert Pornic vers l\'Aéroport Nantes Atlantique est de 110€.'
        }
      ]
    },
    {
      slug: 'vtc-guerande-aeroport',
      from: 'Guérande',
      to: 'Aéroport Nantes Atlantique',
      title: 'VTC Guérande Aéroport - Chauffeur Privé | Réservation Goloire-Cab au 02 59 22 20 00',
      metaDescription: 'Transfert VTC Guérande ↔ Aéroport Nantes ⚡ Service premium 24h/24 🚗 Prix fixe 160€ ✓ Véhicules Tesla ✓ Réservez votre chauffeur !',
      keywords: 'vtc guerande aeroport, transfert guerande aeroport nantes, navette guerande aeroport',
      heroImage: 'https://images.unsplash.com/photo-1436491865332-7a61a109cc05?w=1920&q=80&fm=webp',
      distance: '75 km',
      duration: '55 min',
      price: 'dès 160€',
      priceReturn: 'dès 305€',
      fromCoords: { lat: 47.3278, lng: -2.4297 },
      toCoords: { lat: 47.1531, lng: -1.6108 },
      highlights: [
        'Desserte cité médiévale',
        'Transferts depuis marais salants',
        'Suivi vol en temps réel',
        'Véhicules premium',
        'Service 24/7'
      ],
      description: `Transfert VTC Guérande Aéroport Nantes Atlantique. Profitez d'un service premium pour vos déplacements depuis la cité médiévale de Guérande vers l'aéroport. Chauffeurs professionnels et véhicules haut de gamme.`,
      faq: []
    },
    {
      slug: 'vtc-clisson-aeroport',
      from: 'Clisson',
      to: 'Aéroport Nantes Atlantique',
      title: 'VTC Clisson Aéroport - Chauffeur Privé | Réservation Goloire-Cab au 02 59 22 20 00',
      metaDescription: 'Transfert VTC Clisson ↔ Aéroport Nantes ⚡ Chauffeur privé 🚗 Prix fixe 70€ ✓ Service vignoble ✓ Réservation simple !',
      keywords: 'vtc clisson aeroport, transfert clisson aeroport nantes, navette clisson aeroport',
      heroImage: 'https://images.unsplash.com/photo-1436491865332-7a61a109cc05?w=1920&q=80&fm=webp',
      distance: '35 km',
      duration: '30 min',
      price: 'dès 70€',
      priceReturn: 'dès 135€',
      fromCoords: { lat: 47.0872, lng: -1.2828 },
      toCoords: { lat: 47.1531, lng: -1.6108 },
      highlights: [
        'Desserte vignoble nantais',
        'Prise en charge domaines viticoles',
        'Transferts professionnels',
        'Service rapide',
        'Tarif fixe'
      ],
      description: `Service VTC Clisson vers l'Aéroport Nantes Atlantique. Idéal pour les professionnels du vignoble et les visiteurs du château de Clisson. Transfert rapide et confortable.`,
      faq: []
    },
    {
      slug: 'vtc-ancenis-aeroport',
      from: 'Ancenis',
      to: 'Aéroport Nantes Atlantique',
      title: 'VTC Ancenis Aéroport - Chauffeur Privé | Réservation Goloire-Cab au 02 59 22 20 00',
      metaDescription: 'Transfert VTC Ancenis ↔ Aéroport Nantes ⚡ Service premium 🚗 Prix fixe 120€ ✓ Disponible 24/7 ✓ Réservation en ligne !',
      keywords: 'vtc ancenis aeroport, transfert ancenis aeroport nantes, navette ancenis aeroport',
      heroImage: 'https://images.unsplash.com/photo-1436491865332-7a61a109cc05?w=1920&q=80&fm=webp',
      distance: '45 km',
      duration: '40 min',
      price: 'dès 120€',
      priceReturn: 'dès 230€',
      fromCoords: { lat: 47.3667, lng: -1.1833 },
      toCoords: { lat: 47.1531, lng: -1.6108 },
      highlights: [
        'Liaison directe Est Loire-Atlantique',
        'Service entreprises',
        'Suivi des vols',
        'Véhicules confortables',
        'Disponible 24h/24'
      ],
      description: `Transfert VTC Ancenis vers l'Aéroport Nantes Atlantique. Service premium pour les habitants et professionnels de l'est de la Loire-Atlantique.`,
      faq: []
    },
    {
      slug: 'vtc-reze-aeroport',
      from: 'Rezé',
      to: 'Aéroport Nantes Atlantique',
      title: 'VTC Rezé Aéroport - Chauffeur Privé | Réservation Goloire-Cab au 02 59 22 20 00',
      metaDescription: 'Transfert VTC Rezé ↔ Aéroport Nantes ⚡ Service express 🚗 Prix fixe 35€ ✓ Proximité aéroport ✓ Réservez !',
      keywords: 'vtc reze aeroport, transfert reze aeroport nantes, navette reze aeroport',
      heroImage: 'https://images.unsplash.com/photo-1436491865332-7a61a109cc05?w=1920&q=80&fm=webp',
      distance: '8 km',
      duration: '12 min',
      price: 'dès 35€',
      priceReturn: 'dès 55€',
      fromCoords: { lat: 47.1833, lng: -1.5500 },
      toCoords: { lat: 47.1531, lng: -1.6108 },
      highlights: [
        'Proximité immédiate aéroport',
        'Service ultra-rapide',
        'Prise en charge domicile',
        'Suivi vol',
        'Tarif économique'
      ],
      description: `Transfert express VTC Rezé vers l'Aéroport Nantes Atlantique. Profitez de la proximité pour un trajet rapide et économique.`,
      faq: []
    },
    {
      slug: 'vtc-vertou-aeroport',
      from: 'Vertou',
      to: 'Aéroport Nantes Atlantique',
      title: 'VTC Vertou Aéroport - Chauffeur Privé | Réservation Goloire-Cab au 02 59 22 20 00',
      metaDescription: 'Transfert VTC Vertou ↔ Aéroport Nantes ⚡ Chauffeur privé 🚗 Prix fixe 40€ ✓ Service premium ✓ Réservez !',
      keywords: 'vtc vertou aeroport, transfert vertou aeroport nantes, navette vertou aeroport',
      heroImage: 'https://images.unsplash.com/photo-1436491865332-7a61a109cc05?w=1920&q=80&fm=webp',
      distance: '15 km',
      duration: '20 min',
      price: 'dès 40€',
      priceReturn: 'dès 65€',
      fromCoords: { lat: 47.1681, lng: -1.4692 },
      toCoords: { lat: 47.1531, lng: -1.6108 },
      highlights: [
        'Desserte sud métropole',
        'Service vignoble',
        'Prise en charge rapide',
        'Véhicules premium'
      ],
      description: `VTC Vertou vers l'Aéroport Nantes Atlantique. Service de transfert premium depuis Vertou et le vignoble nantais.`,
      faq: []
    },
    {
      slug: 'vtc-carquefou-aeroport',
      from: 'Carquefou',
      to: 'Aéroport Nantes Atlantique',
      title: 'VTC Carquefou Aéroport - Chauffeur Privé | Réservation Goloire-Cab au 02 59 22 20 00',
      metaDescription: 'Transfert VTC Carquefou ↔ Aéroport Nantes ⚡ Service entreprises 🚗 Prix fixe 75€ ✓ Zones business ✓ Réservez !',
      keywords: 'vtc carquefou aeroport, transfert carquefou aeroport nantes, navette carquefou aeroport',
      heroImage: 'https://images.unsplash.com/photo-1436491865332-7a61a109cc05?w=1920&q=80&fm=webp',
      distance: '18 km',
      duration: '25 min',
      price: 'dès 75€',
      priceReturn: 'dès 140€',
      fromCoords: { lat: 47.2978, lng: -1.4933 },
      toCoords: { lat: 47.1531, lng: -1.6108 },
      highlights: [
        'Spécialiste zones d\'activité',
        'Service entreprises',
        'Transferts professionnels',
        'Facturation société'
      ],
      description: `Transfert VTC business Carquefou vers l'Aéroport Nantes Atlantique. Service adapté aux entreprises et parcs d'activités.`,
      faq: []
    },
    {
      slug: 'vtc-orvault-aeroport',
      from: 'Orvault',
      to: 'Aéroport Nantes Atlantique',
      title: 'VTC Orvault Aéroport - Chauffeur Privé | Réservation Goloire-Cab au 02 59 22 20 00',
      metaDescription: 'Transfert VTC Orvault ↔ Aéroport Nantes ⚡ Chauffeur privé 🚗 Prix fixe 50€ ✓ Service 24/7 ✓ Réservez !',
      keywords: 'vtc orvault aeroport, transfert orvault aeroport nantes, navette orvault aeroport',
      heroImage: 'https://images.unsplash.com/photo-1436491865332-7a61a109cc05?w=1920&q=80&fm=webp',
      distance: '12 km',
      duration: '18 min',
      price: 'dès 50€',
      priceReturn: 'dès 95€',
      fromCoords: { lat: 47.2711, lng: -1.6217 },
      toCoords: { lat: 47.1531, lng: -1.6108 },
      highlights: [
        'Nord métropole nantaise',
        'Trajet rapide',
        'Service premium',
        'Disponible 24h/24'
      ],
      description: `VTC Orvault vers l'Aéroport Nantes Atlantique. Transfert rapide et confortable depuis le nord de la métropole.`,
      faq: []
    },
    {
      slug: 'vtc-saint-herblain-aeroport',
      from: 'Saint-Herblain',
      to: 'Aéroport Nantes Atlantique',
      title: 'VTC Saint-Herblain Aéroport - Chauffeur Privé | Réservation Goloire-Cab au 02 59 22 20 00',
      metaDescription: 'Transfert VTC Saint-Herblain ↔ Aéroport Nantes ⚡ Service rapide 🚗 Prix fixe 35€ ✓ Atlantis ✓ Réservez !',
      keywords: 'vtc saint herblain aeroport, transfert saint herblain aeroport, navette atlantis aeroport',
      heroImage: 'https://images.unsplash.com/photo-1436491865332-7a61a109cc05?w=1920&q=80&fm=webp',
      distance: '10 km',
      duration: '15 min',
      price: 'dès 35€',
      priceReturn: 'dès 65€',
      fromCoords: { lat: 47.2128, lng: -1.6497 },
      toCoords: { lat: 47.1531, lng: -1.6108 },
      highlights: [
        'Desserte centre commercial Atlantis',
        'Proximité aéroport',
        'Service express',
        'Prix économique'
      ],
      description: `Transfert VTC Saint-Herblain vers l'Aéroport Nantes Atlantique. Service rapide depuis Atlantis et le centre.`,
      faq: []
    },
    {
      slug: 'vtc-bouguenais-aeroport',
      from: 'Bouguenais',
      to: 'Aéroport Nantes Atlantique',
      title: 'VTC Bouguenais Aéroport - Chauffeur Privé | Réservation Goloire-Cab au 02 59 22 20 00',
      metaDescription: 'Transfert VTC Bouguenais ↔ Aéroport Nantes ⚡ Service ultra-proche 🚗 Prix fixe 30€ ✓ Pôle aéronautique ✓ Réservez !',
      keywords: 'vtc bouguenais aeroport, transfert bouguenais aeroport, navette pole aeronautique aeroport',
      heroImage: 'https://images.unsplash.com/photo-1436491865332-7a61a109cc05?w=1920&q=80&fm=webp',
      distance: '5 km',
      duration: '8 min',
      price: 'dès 30€',
      priceReturn: 'dès 55€',
      fromCoords: { lat: 47.1781, lng: -1.6194 },
      toCoords: { lat: 47.1531, lng: -1.6108 },
      highlights: [
        'Commune de l\'aéroport',
        'Desserte pôle aéronautique',
        'Service ultra-rapide',
        'Tarif minimal'
      ],
      description: `Transfert VTC Bouguenais vers l'Aéroport Nantes Atlantique. Service express depuis la commune de l'aéroport et les sites industriels aéronautiques.`,
      faq: []
    },
    {
      slug: 'vtc-challans-aeroport',
      from: 'Challans',
      to: 'Aéroport Nantes Atlantique',
      title: 'VTC Challans Aéroport - Chauffeur Privé | Réservation Goloire-Cab au 02 59 22 20 00',
      metaDescription: 'Transfert VTC Challans ↔ Aéroport Nantes ⚡ Service Vendée 🚗 Prix fixe 160€ ✓ Disponible 24/7 ✓ Réservez !',
      keywords: 'vtc challans aeroport, transfert challans aeroport nantes, navette challans aeroport',
      heroImage: 'https://images.unsplash.com/photo-1436491865332-7a61a109cc05?w=1920&q=80&fm=webp',
      distance: '65 km',
      duration: '55 min',
      price: 'dès 160€',
      priceReturn: 'dès 305€',
      fromCoords: { lat: 46.8467, lng: -1.8783 },
      toCoords: { lat: 47.1531, lng: -1.6108 },
      highlights: [
        'Liaison Vendée-Aéroport',
        'Service premium',
        'Suivi des vols',
        'Véhicules spacieux'
      ],
      description: `Transfert VTC Challans (Vendée) vers l'Aéroport Nantes Atlantique. Service premium pour le nord Vendée.`,
      faq: []
    },
    {
      slug: 'vtc-noirmoutier-aeroport',
      from: 'Noirmoutier',
      to: 'Aéroport Nantes Atlantique',
      title: 'VTC Noirmoutier Aéroport - Chauffeur Privé | Réservation Goloire-Cab au 02 59 22 20 00',
      metaDescription: 'Transfert VTC Île de Noirmoutier ↔ Aéroport Nantes ⚡ Service insulaire 🚗 Prix fixe 205€ ✓ Passage du Gois ✓ Réservez !',
      keywords: 'vtc noirmoutier aeroport, transfert noirmoutier aeroport nantes, navette noirmoutier aeroport',
      heroImage: 'https://images.unsplash.com/photo-1436491865332-7a61a109cc05?w=1920&q=80&fm=webp',
      distance: '85 km',
      duration: '1h15',
      price: 'dès 205€',
      priceReturn: 'dès 390€',
      fromCoords: { lat: 46.9983, lng: -2.2450 },
      toCoords: { lat: 47.1531, lng: -1.6108 },
      highlights: [
        'Desserte île de Noirmoutier',
        'Passage Gois ou pont',
        'Service touristique',
        'Bagages volumineux'
      ],
      description: `Transfert VTC Île de Noirmoutier vers l'Aéroport Nantes Atlantique. Service adapté aux contraintes insulaires.`,
      faq: []
    },
    {
      slug: 'vtc-les-sables-dolonne-aeroport',
      from: 'Les Sables-d\'Olonne',
      to: 'Aéroport Nantes Atlantique',
      title: 'VTC Les Sables-d\'Olonne Aéroport Nantes | Goloire-Cab',
      metaDescription: 'Transfert VTC Les Sables-d\'Olonne ↔ Aéroport Nantes ⚡ Service Vendée 🚗 Prix fixe 240€ ✓ Vendée Globe ✓ Réservez !',
      keywords: 'vtc les sables dolonne aeroport, transfert sables olonne aeroport, navette sables dolonne aeroport',
      heroImage: 'https://images.unsplash.com/photo-1436491865332-7a61a109cc05?w=1920&q=80&fm=webp',
      distance: '100 km',
      duration: '1h20',
      price: 'dès 240€',
      priceReturn: 'dès 430€',
      fromCoords: { lat: 46.4967, lng: -1.7850 },
      toCoords: { lat: 47.1531, lng: -1.6108 },
      highlights: [
        'Capitale du Vendée Globe',
        'Service touristique premium',
        'Suivi des vols',
        'Véhicules confortables'
      ],
      description: `Transfert VTC Les Sables-d'Olonne vers l'Aéroport Nantes Atlantique. Service premium depuis la capitale du Vendée Globe.`,
      faq: []
    },
    // ===== MAINE-ET-LOIRE (49) =====
    {
      slug: 'vtc-cholet-aeroport',
      from: 'Cholet',
      to: 'Aéroport Nantes Atlantique',
      title: 'VTC Cholet Aéroport Nantes - Chauffeur Privé | Réservation Goloire-Cab au 02 59 22 20 00',
      metaDescription: 'Transfert VTC Cholet ↔ Aéroport Nantes Atlantique ⚡ Service premium 24h/24 🚗 Prix fixe 205€ ✓ Suivi des vols ✓ Capitale des Mauges ✓ Réservez !',
      keywords: 'vtc cholet aeroport, transfert cholet aeroport nantes, navette cholet aeroport, taxi cholet aeroport, chauffeur privé cholet nantes',
      heroImage: 'https://images.unsplash.com/photo-1436491865332-7a61a109cc05?w=1920&q=80&fm=webp',
      distance: '70 km',
      duration: '55 min',
      price: 'dès 205€',
      priceReturn: 'dès 390€',
      fromCoords: { lat: 47.0601, lng: -0.8788 },
      toCoords: { lat: 47.1531, lng: -1.6108 },
      highlights: [
        'Prise en charge à domicile ou gare SNCF Cholet',
        'Suivi des vols en temps réel',
        'Attente gratuite (retard avion)',
        'Aide aux bagages incluse',
        'Véhicules Tesla & Kia EV6 spacieux',
        'Service 24h/24, 7j/7',
        'Alternative confortable au TGV+Navette'
      ],
      description: `Service de transfert VTC premium entre Cholet et l'Aéroport Nantes Atlantique. Goloire-Cab assure la liaison directe depuis la capitale des Mauges vers l'aéroport en 55 minutes. Plus rapide et confortable que la correspondance TGV puis navette aéroport, notre service vous dépose directement au terminal de départ. Nos chauffeurs suivent votre vol en temps réel et s'adaptent aux retards sans frais supplémentaires. Idéal pour les voyageurs d'affaires de la zone industrielle de Cholet et les familles en partance pour les vacances.`,
      faq: [
        {
          question: 'Combien coûte un VTC Cholet Aéroport Nantes ?',
          answer: 'Le transfert VTC Cholet vers l\'Aéroport Nantes Atlantique est à 205€ en tarif fixe tout compris. Ce prix inclut la prise en charge à domicile, l\'aide aux bagages et le suivi de vol.'
        },
        {
          question: 'Combien de temps dure le trajet Cholet Aéroport ?',
          answer: 'Le trajet Cholet-Aéroport Nantes dure environ 55 minutes via l\'A87 et le périphérique nantais. C\'est plus rapide qu\'un TGV vers Nantes puis navette aéroport.'
        },
        {
          question: 'Pouvez-vous me prendre à la gare SNCF de Cholet ?',
          answer: 'Oui, nous proposons des transferts depuis la gare SNCF de Cholet vers l\'aéroport, idéal si vous arrivez en TGV depuis Paris et devez prendre un vol.'
        },
        {
          question: 'Que se passe-t-il si mon vol est en retard ?',
          answer: 'Nous suivons votre vol en temps réel. En cas de retard à l\'arrivée, votre chauffeur ajuste son horaire sans frais supplémentaires.'
        }
      ]
    },
    // ===== ANGERS - MAINE-ET-LOIRE (49) =====
    {
      slug: 'vtc-angers-aeroport',
      from: 'Angers',
      to: 'Aéroport Nantes Atlantique',
      title: 'VTC Angers Aéroport Nantes - Chauffeur Privé | Réservation Goloire-Cab au 02 59 22 20 00',
      metaDescription: 'Transfert VTC Angers ↔ Aéroport Nantes Atlantique ⚡ Capitale de l\'Anjou 🚗 Prix fixe 205€ ✓ Suivi des vols ✓ Alternative au TGV ✓ Réservez !',
      keywords: 'vtc angers aeroport, transfert angers aeroport nantes, navette angers aeroport, chauffeur privé angers nantes, taxi angers aeroport',
      heroImage: 'https://images.unsplash.com/photo-1436491865332-7a61a109cc05?w=1920&q=80&fm=webp',
      distance: '95 km',
      duration: '1h00',
      price: 'dès 205€',
      priceReturn: 'dès 390€',
      fromCoords: { lat: 47.4784, lng: -0.5632 },
      toCoords: { lat: 47.1531, lng: -1.6108 },
      highlights: [
        'Capitale de l\'Anjou vers l\'aéroport',
        'Plus rapide que TGV + navette',
        'Suivi des vols en temps réel',
        'Attente gratuite (retard avion)',
        'Prise en charge à domicile ou gare',
        'Véhicules Tesla & Kia EV6',
        'Service 24h/24'
      ],
      description: `Service de transfert VTC premium entre Angers et l'Aéroport Nantes Atlantique. Goloire-Cab assure la liaison directe depuis la capitale de l'Anjou vers l'aéroport en 1h environ. 

Cette solution est plus rapide et plus confortable que la correspondance TGV Angers-Nantes (40 min) puis tramway/navette vers l'aéroport (30-40 min), soit environ 1h30 au total avec les correspondances. Notre transfert direct vous fait gagner du temps et du stress.

Idéal pour les voyageurs d'affaires angevins, les touristes visitant les Châteaux de la Loire, et les familles avec bagages. Nos chauffeurs suivent votre vol en temps réel.`,
      faq: [
        {
          question: 'Combien coûte un VTC Angers Aéroport Nantes ?',
          answer: 'Le transfert VTC Angers vers l\'Aéroport Nantes Atlantique est à 205€ en tarif fixe tout compris. Ce prix inclut la prise en charge à domicile, l\'aide aux bagages et le suivi de vol.'
        },
        {
          question: 'Combien de temps dure le trajet Angers Aéroport Nantes ?',
          answer: 'Le trajet Angers-Aéroport Nantes dure environ 1h via l\'A11 et le périphérique nantais. C\'est plus rapide que le TGV vers Nantes (40 min) puis navette aéroport (30-40 min).'
        },
        {
          question: 'Pouvez-vous me prendre à la gare SNCF d\'Angers ?',
          answer: 'Oui, nous proposons des transferts depuis la gare SNCF Saint-Laud d\'Angers vers l\'aéroport Nantes, idéal pour les correspondances TGV-avion.'
        },
        {
          question: 'Le VTC est-il plus intéressant que le train ?',
          answer: 'Pour 2-3 personnes voyageant ensemble, le VTC est souvent plus avantageux que les billets TGV individuels + navette. De plus, c\'est porte-à-porte et sans correspondance.'
        }
      ]
    },
    // ===== RENNES - ILLE-ET-VILAINE (35) =====
    {
      slug: 'vtc-rennes-aeroport',
      from: 'Rennes',
      to: 'Aéroport Nantes Atlantique',
      title: 'VTC Rennes Aéroport Nantes - Chauffeur Privé | Réservation Goloire-Cab au 02 59 22 20 00',
      metaDescription: 'Transfert VTC Rennes ↔ Aéroport Nantes Atlantique ⚡ Capitale de Bretagne 🚗 Prix fixe 290€ ✓ Suivi des vols ✓ Plus de choix de vols ✓ Réservez !',
      keywords: 'vtc rennes aeroport nantes, transfert rennes aeroport nantes, navette rennes aeroport nantes, chauffeur privé rennes nantes, taxi rennes aeroport',
      heroImage: 'https://images.unsplash.com/photo-1436491865332-7a61a109cc05?w=1920&q=80&fm=webp',
      distance: '115 km',
      duration: '1h15',
      price: 'dès 290€',
      priceReturn: 'dès 540€',
      fromCoords: { lat: 48.1173, lng: -1.6778 },
      toCoords: { lat: 47.1531, lng: -1.6108 },
      highlights: [
        'Capitale de Bretagne vers Nantes',
        'Plus de destinations que Rennes Airport',
        'Suivi des vols en temps réel',
        'Attente gratuite (retard avion)',
        'Alternative à l\'aéroport de Rennes',
        'Véhicules premium confortables',
        'Service 24h/24'
      ],
      description: `Service de transfert VTC premium entre Rennes et l'Aéroport Nantes Atlantique. Une alternative intéressante à l'aéroport de Rennes-Saint-Jacques qui propose moins de destinations.

L'Aéroport Nantes Atlantique offre plus de 120 destinations contre une cinquantaine pour Rennes. Pour certaines destinations (Maghreb, Europe du Sud, low-cost), le transfert vers Nantes peut s'avérer plus économique que le vol direct depuis Rennes.

Nos chauffeurs vous prennent en charge à Rennes (domicile, gare, hôtel) et vous déposent directement au terminal de l'aéroport Nantes. Service de suivi de vol pour les retours.`,
      faq: [
        {
          question: 'Pourquoi choisir Nantes plutôt que l\'aéroport de Rennes ?',
          answer: 'L\'aéroport Nantes Atlantique propose plus de 120 destinations contre environ 50 pour Rennes. Pour de nombreuses destinations (low-cost, Maghreb, Europe du Sud), les vols sont moins chers ou plus fréquents depuis Nantes.'
        },
        {
          question: 'Combien coûte un VTC Rennes Aéroport Nantes ?',
          answer: 'Le transfert VTC Rennes vers l\'Aéroport Nantes Atlantique est à 290€ en tarif fixe tout compris. Pour 2-3 personnes, c\'est souvent plus avantageux que les transports en commun.'
        },
        {
          question: 'Combien de temps dure le trajet Rennes Aéroport Nantes ?',
          answer: 'Le trajet Rennes-Aéroport Nantes dure environ 1h15 via la N137. C\'est un trajet direct et confortable en véhicule premium.'
        },
        {
          question: 'Pouvez-vous me récupérer à la gare de Rennes ?',
          answer: 'Oui, nous assurons les transferts depuis la gare SNCF de Rennes vers l\'aéroport Nantes, idéal pour les voyageurs arrivant en TGV depuis Paris.'
        }
      ]
    },
    // ===== VANNES - MORBIHAN (56) =====
    {
      slug: 'vtc-vannes-aeroport',
      from: 'Vannes',
      to: 'Aéroport Nantes Atlantique',
      title: 'VTC Vannes Aéroport Nantes - Chauffeur Privé | Réservation Goloire-Cab au 02 59 22 20 00',
      metaDescription: 'Transfert VTC Vannes ↔ Aéroport Nantes Atlantique ⚡ Golfe du Morbihan 🚗 Prix fixe 315€ ✓ Suivi des vols ✓ Plus de destinations ✓ Réservez !',
      keywords: 'vtc vannes aeroport nantes, transfert vannes aeroport nantes, navette vannes aeroport nantes, chauffeur privé vannes, taxi vannes aeroport',
      heroImage: 'https://images.unsplash.com/photo-1436491865332-7a61a109cc05?w=1920&q=80&fm=webp',
      distance: '120 km',
      duration: '1h20',
      price: 'dès 315€',
      priceReturn: 'dès 585€',
      fromCoords: { lat: 47.6559, lng: -2.7603 },
      toCoords: { lat: 47.1531, lng: -1.6108 },
      highlights: [
        'Golfe du Morbihan vers l\'aéroport',
        'Alternative à Lorient Airport',
        'Suivi des vols en temps réel',
        'Attente gratuite (retard avion)',
        '120+ destinations depuis Nantes',
        'Idéal touristes Golfe du Morbihan',
        'Service 24h/24'
      ],
      description: `Service de transfert VTC premium entre Vannes et l'Aéroport Nantes Atlantique. La solution idéale pour les habitants du Golfe du Morbihan et les touristes visitant cette magnifique région.

L'Aéroport Nantes Atlantique offre bien plus de destinations que l'aéroport de Lorient-Bretagne Sud. Pour les vols internationaux, low-cost ou destinations touristiques populaires, Nantes est souvent le meilleur choix.

Nos chauffeurs vous prennent en charge à Vannes, Auray, Baden ou toute commune du Golfe du Morbihan. Service idéal pour les touristes en fin de séjour ou les résidents secondaires.`,
      faq: [
        {
          question: 'Pourquoi choisir Nantes plutôt que Lorient ?',
          answer: 'L\'aéroport Nantes Atlantique propose plus de 120 destinations contre une dizaine pour Lorient. Pour la plupart des voyages (Europe, Maghreb, DOM-TOM), Nantes est le meilleur choix depuis le Morbihan.'
        },
        {
          question: 'Combien coûte un VTC Vannes Aéroport Nantes ?',
          answer: 'Le transfert VTC Vannes vers l\'Aéroport Nantes Atlantique est à 315€ en tarif fixe tout compris. Pour les familles ou groupes, c\'est très compétitif.'
        },
        {
          question: 'Pouvez-vous me prendre ailleurs qu\'à Vannes ?',
          answer: 'Oui, nous desservons tout le Golfe du Morbihan : Auray, Baden, Arradon, Séné, Île aux Moines (embarcadère). Tarif ajusté selon le point de prise en charge.'
        },
        {
          question: 'Proposez-vous des transferts pour les touristes ?',
          answer: 'Absolument ! Nous proposons des transferts pour les touristes en fin de séjour dans le Golfe du Morbihan. Service de prise en charge à l\'hébergement (hôtel, gîte, camping).'
        }
      ]
    },
    // =====================================================
    // NOUVEAUX TRAJETS AÉROPORT NTE (avril 2026) — Tours, Saumur, Vendée top 10
    // =====================================================
    {
      slug: 'vtc-tours-aeroport',
      from: 'Tours',
      to: 'Aéroport Nantes Atlantique',
      title: 'VTC Tours Aéroport Nantes - Transfert Premium | Goloire-Cab 02 59 22 20 00',
      metaDescription: 'Transfert VTC Tours ↔ Aéroport Nantes Atlantique ⭐ 215 km, 2h10 🚗 Tesla & Kia EV6 ✓ Prix fixe dès 325€ ✓ Suivi de vol ✓ Service 24h/24.',
      keywords: 'vtc tours aeroport nantes, transfert tours aeroport, chauffeur prive tours nantes, navette tours aeroport',
      heroImage: 'https://images.unsplash.com/photo-1436491865332-7a61a109cc05?w=1920&q=80&fm=webp',
      distance: '215 km', duration: '2h10', price: 'dès 325€', priceReturn: 'dès 590€',
      fromCoords: { lat: 47.3941, lng: 0.6848 }, toCoords: { lat: 47.1531, lng: -1.6108 },
      highlights: [
        'Prise en charge Tours centre, gare TGV Saint-Pierre, hôtels',
        'Autoroute A85 / A11 via Angers',
        'Suivi de vol en temps réel',
        'Véhicules Tesla premium pour longue distance',
        'Aide aux bagages incluse',
        'Service 24h/24 incluant vols tôt le matin'
      ],
      description: `Service VTC longue distance entre Tours (Indre-et-Loire, 37) et l'Aéroport Nantes Atlantique. Goloire-Cab assure vos transferts depuis le cœur du Val de Loire vers le plus grand aéroport de l'Ouest. Prise en charge à votre adresse Tours centre-ville, gare TGV Saint-Pierre-des-Corps, hôtels Mercure, Ibis, Novotel, Kyriad, ou directement sur la rive droite (Saint-Cyr-sur-Loire, Fondettes).\n\nNos chauffeurs professionnels connaissent parfaitement l'itinéraire A85/A11 via Angers. Pour les vols tôt le matin (navettes Easyjet, Transavia, Volotea), réservez la veille pour garantir votre tranquillité.`,
      faq: [
        { question: 'Combien coûte un VTC Tours → Aéroport Nantes ?', answer: 'Le transfert Tours ↔ Aéroport Nantes Atlantique démarre à 325€ tarif fixe (215 km). Aller-retour possible dès 590€. Suivi de vol inclus.' },
        { question: 'Combien de temps dure le trajet ?', answer: 'Comptez 2h10 via l\'autoroute A85 + A11 (via Angers). Nous prévoyons 3h de marge avant un vol international.' },
        { question: 'Prenez-vous en charge les bagages volumineux ?', answer: 'Oui, nos Tesla Model Y et Kia EV6 acceptent jusqu\'à 4 valises 23 kg + bagages cabine pour 4 passagers.' }
      ]
    },
    {
      slug: 'vtc-saumur-aeroport',
      from: 'Saumur',
      to: 'Aéroport Nantes Atlantique',
      title: 'VTC Saumur Aéroport Nantes - Chauffeur Privé | Goloire-Cab 02 59 22 20 00',
      metaDescription: 'Transfert VTC Saumur ↔ Aéroport Nantes Atlantique ⭐ 140 km, 1h30 🚗 Château de Saumur, vignobles ✓ Prix fixe dès 295€ ✓ Suivi de vol.',
      keywords: 'vtc saumur aeroport nantes, transfert saumur aeroport, chauffeur prive saumur, navette saumur aeroport nantes',
      heroImage: 'https://images.unsplash.com/photo-1436491865332-7a61a109cc05?w=1920&q=80&fm=webp',
      distance: '140 km', duration: '1h30', price: 'dès 295€', priceReturn: 'dès 560€',
      fromCoords: { lat: 47.2598, lng: -0.0738 }, toCoords: { lat: 47.1531, lng: -1.6108 },
      highlights: [
        'Prise en charge Saumur centre, château, gare SNCF',
        'Desserte hôtels & domaines viticoles',
        'Autoroute A85 directe',
        'Suivi de vol en temps réel',
        'Chauffeurs connaissant le Val de Loire',
        'Service bilingue pour touristes internationaux'
      ],
      description: `Transfert VTC entre Saumur (Maine-et-Loire, 49) et l'Aéroport Nantes Atlantique. Prise en charge au château de Saumur, gare SNCF, hôtels Adagio, Kyriad, Mercure, ou sur les domaines viticoles AOC Saumur-Champigny. Autoroute A85 via Angers, service adapté aux visiteurs internationaux des vignobles et du Cadre Noir.`,
      faq: [
        { question: 'Quel est le prix VTC Saumur → Aéroport Nantes ?', answer: 'Tarif fixe dès 295€ tout compris (140 km, 1h30). Aller-retour possible dès 295€.' },
        { question: 'Desservez-vous les domaines viticoles ?', answer: 'Oui, prise en charge sur tous les domaines AOC Saumur-Champigny, Coteaux-de-Saumur et Bourgueil.' }
      ]
    },
    {
      slug: 'vtc-la-roche-sur-yon-aeroport',
      from: 'La Roche-sur-Yon',
      to: 'Aéroport Nantes Atlantique',
      title: 'VTC La Roche-sur-Yon Aéroport Nantes | Goloire-Cab 02 59 22 20 00',
      metaDescription: 'Transfert VTC La Roche-sur-Yon ↔ Aéroport Nantes Atlantique ⭐ 70 km, 55 min 🚗 Préfecture Vendée ✓ Prix fixe dès 150€ ✓ 24h/24.',
      keywords: 'vtc la roche sur yon aeroport nantes, transfert la roche aeroport, chauffeur prive la roche sur yon, navette vendee aeroport',
      heroImage: 'https://images.unsplash.com/photo-1436491865332-7a61a109cc05?w=1920&q=80&fm=webp',
      distance: '70 km', duration: '55 min', price: 'dès 150€', priceReturn: 'dès 285€',
      fromCoords: { lat: 46.6704, lng: -1.4264 }, toCoords: { lat: 47.1531, lng: -1.6108 },
      highlights: [
        'Liaison rapide A83',
        'Prise en charge préfecture, gare SNCF, CHD',
        'Vols tôt le matin (business travel)',
        'Suivi de vol inclus',
        'Service 24h/24 toute l\'année'
      ],
      description: `VTC La Roche-sur-Yon vers l'Aéroport Nantes Atlantique. Liaison directe via A83 (70 km, 55 minutes). Desserte de la préfecture de Vendée, gare SNCF, CHD Les Oudairies, Vendéspace. Idéal pour voyages d'affaires et vacanciers vendéens.`,
      faq: [
        { question: 'Prix VTC La Roche-sur-Yon → Aéroport Nantes ?', answer: 'Tarif fixe dès 150€ pour le trajet simple (70 km), 150€ aller-retour. Suivi de vol inclus.' }
      ]
    },
    {
      slug: 'vtc-fontenay-le-comte-aeroport',
      from: 'Fontenay-le-Comte',
      to: 'Aéroport Nantes Atlantique',
      title: 'VTC Fontenay-le-Comte Aéroport Nantes | Goloire-Cab 02 59 22 20 00',
      metaDescription: 'Transfert VTC Fontenay-le-Comte ↔ Aéroport Nantes Atlantique ⭐ 125 km, 1h30 🚗 Sud-Vendée ✓ Prix fixe dès 265€ ✓ 24h/24.',
      keywords: 'vtc fontenay le comte aeroport, transfert fontenay aeroport nantes, chauffeur prive sud vendee aeroport',
      heroImage: 'https://images.unsplash.com/photo-1436491865332-7a61a109cc05?w=1920&q=80&fm=webp',
      distance: '125 km', duration: '1h30', price: 'dès 265€', priceReturn: 'dès 505€',
      fromCoords: { lat: 46.4650, lng: -0.8086 }, toCoords: { lat: 47.1531, lng: -1.6108 },
      highlights: [
        'Porte du Marais Poitevin',
        'Autoroute A83 directe',
        'Service Sud-Vendée',
        'Suivi de vol inclus',
        'Véhicules spacieux longue distance'
      ],
      description: `VTC Fontenay-le-Comte vers Aéroport Nantes Atlantique. Liaison A83 (125 km, 1h30). Prise en charge centre historique Renaissance, château de Terre-Neuve, hôtels et gîtes du Marais Poitevin.`,
      faq: [
        { question: 'Combien coûte un VTC Fontenay → Aéroport Nantes ?', answer: 'Tarif fixe dès 265€ tout compris (125 km, 1h30).' }
      ]
    },
    {
      slug: 'vtc-saint-gilles-croix-de-vie-aeroport',
      from: 'Saint-Gilles-Croix-de-Vie',
      to: 'Aéroport Nantes Atlantique',
      title: 'VTC Saint-Gilles-Croix-de-Vie Aéroport Nantes | Goloire-Cab',
      metaDescription: 'Transfert VTC Saint-Gilles-Croix-de-Vie ↔ Aéroport Nantes ⭐ 75 km, 1h 🚗 Côte vendéenne ✓ Prix fixe dès 160€ ✓ 24h/24.',
      keywords: 'vtc saint gilles croix de vie aeroport, transfert saint gilles aeroport nantes, chauffeur prive cote vendeenne',
      heroImage: 'https://images.unsplash.com/photo-1436491865332-7a61a109cc05?w=1920&q=80&fm=webp',
      distance: '75 km', duration: '1h', price: 'dès 160€', priceReturn: 'dès 305€',
      fromCoords: { lat: 46.6942, lng: -1.9419 }, toCoords: { lat: 47.1531, lng: -1.6108 },
      highlights: [
        'Port de pêche & station balnéaire',
        'Prise en charge hôtels front de mer, casino',
        'Retour Île d\'Yeu (gare maritime)',
        'Suivi de vol inclus',
        'Service 7j/7 saison estivale'
      ],
      description: `VTC Saint-Gilles-Croix-de-Vie vers Aéroport Nantes Atlantique. Idéal pour les vacanciers de la côte vendéenne, résidents secondaires, et voyageurs Île d'Yeu. Prise en charge hôtels Kyriad, Ibis, Mercure, campings 4/5★, casino et gare maritime.`,
      faq: [
        { question: 'Tarif VTC Saint-Gilles → Aéroport Nantes ?', answer: 'Tarif fixe dès 160€ (75 km, 1h). Aller-retour possible à 305€. Suivi de vol inclus.' }
      ]
    },
    {
      slug: 'vtc-saint-hilaire-de-riez-aeroport',
      from: 'Saint-Hilaire-de-Riez',
      to: 'Aéroport Nantes Atlantique',
      title: 'VTC Saint-Hilaire-de-Riez Aéroport Nantes | Goloire-Cab',
      metaDescription: 'Transfert VTC Saint-Hilaire-de-Riez ↔ Aéroport Nantes ⭐ 75 km, 1h 🚗 Sion-sur-l\'Océan ✓ Prix fixe dès 160€ ✓ 24h/24.',
      keywords: 'vtc saint hilaire de riez aeroport, transfert saint hilaire aeroport nantes, navette sion ocean aeroport',
      heroImage: 'https://images.unsplash.com/photo-1436491865332-7a61a109cc05?w=1920&q=80&fm=webp',
      distance: '75 km', duration: '1h', price: 'dès 160€', priceReturn: 'dès 305€',
      fromCoords: { lat: 46.7208, lng: -1.9444 }, toCoords: { lat: 47.1531, lng: -1.6108 },
      highlights: [
        'Station balnéaire Sion-sur-l\'Océan',
        'Prise en charge campings, villas, hôtels',
        'Retour vacanciers fin de séjour',
        'Suivi de vol inclus',
        'Forfait famille (4 pax + bagages)'
      ],
      description: `VTC Saint-Hilaire-de-Riez vers Aéroport Nantes Atlantique. Grande station balnéaire avec forêt dunaire et 14 km de plages. Prise en charge campings 4/5★ (Les Ecureuils, Les Biches, La Yole), villas, résidences de tourisme et hôtels Sion-sur-l'Océan.`,
      faq: [
        { question: 'Prix VTC Saint-Hilaire-de-Riez → Aéroport Nantes ?', answer: 'Tarif fixe dès 160€ (75 km, 1h).' }
      ]
    },
    {
      slug: 'vtc-lucon-aeroport',
      from: 'Luçon',
      to: 'Aéroport Nantes Atlantique',
      title: 'VTC Luçon Aéroport Nantes - Transfert Sud-Vendée | Goloire-Cab',
      metaDescription: 'Transfert VTC Luçon ↔ Aéroport Nantes Atlantique ⭐ 115 km, 1h25 🚗 Cathédrale Sud-Vendée ✓ Prix fixe dès 245€ ✓ 24h/24.',
      keywords: 'vtc lucon aeroport, transfert lucon aeroport nantes, chauffeur prive lucon, navette sud vendee',
      heroImage: 'https://images.unsplash.com/photo-1436491865332-7a61a109cc05?w=1920&q=80&fm=webp',
      distance: '115 km', duration: '1h25', price: 'dès 245€', priceReturn: 'dès 465€',
      fromCoords: { lat: 46.4558, lng: -1.1658 }, toCoords: { lat: 47.1531, lng: -1.6108 },
      highlights: [
        'Cité épiscopale du Sud-Vendée',
        'Autoroute A83 via La Roche-sur-Yon',
        'Prise en charge cathédrale, jardin Dumaine',
        'Suivi de vol inclus',
        'Service 24h/24'
      ],
      description: `VTC Luçon vers Aéroport Nantes Atlantique. Liaison A83 (115 km, 1h25). Prise en charge à la cathédrale Notre-Dame, jardin Dumaine, hôtels du centre historique.`,
      faq: [
        { question: 'Prix VTC Luçon → Aéroport Nantes ?', answer: 'Tarif fixe dès 245€ (115 km, 1h25). Aller-retour 465€.' }
      ]
    },
    {
      slug: 'vtc-les-herbiers-aeroport',
      from: 'Les Herbiers',
      to: 'Aéroport Nantes Atlantique',
      title: 'VTC Les Herbiers Aéroport Nantes - Transfert Bocage | Goloire-Cab',
      metaDescription: 'Transfert VTC Les Herbiers ↔ Aéroport Nantes Atlantique ⭐ 85 km, 1h10 🚗 Bocage Vendéen, proche Puy du Fou ✓ Prix fixe dès 160€ ✓ 24h/24.',
      keywords: 'vtc les herbiers aeroport, transfert les herbiers aeroport nantes, chauffeur prive puy du fou aeroport',
      heroImage: 'https://images.unsplash.com/photo-1436491865332-7a61a109cc05?w=1920&q=80&fm=webp',
      distance: '85 km', duration: '1h10', price: 'dès 160€', priceReturn: 'dès 305€',
      fromCoords: { lat: 46.8694, lng: -1.0122 }, toCoords: { lat: 47.1531, lng: -1.6108 },
      highlights: [
        'Bocage Vendéen, porte du Puy du Fou',
        'Desserte Mont des Alouettes',
        'Retour visiteurs Puy du Fou vers aéroport',
        'Suivi de vol inclus',
        'Service dimanche & jours fériés'
      ],
      description: `VTC Les Herbiers vers Aéroport Nantes Atlantique. Idéal pour les visiteurs du Puy du Fou (à 12 km) souhaitant rejoindre l'aéroport après leur séjour. Prise en charge hôtels Puy du Fou (La Villa Gallo-Romaine, Les Deux Couronnes, La Citadelle), Mont des Alouettes, gîtes du Bocage.`,
      faq: [
        { question: 'Prix VTC Les Herbiers → Aéroport Nantes ?', answer: 'Tarif fixe dès 160€ (85 km, 1h10). Forfait combiné Puy du Fou + aéroport sur devis.' },
        { question: 'Desservez-vous les hôtels du Puy du Fou ?', answer: 'Oui, prise en charge directe sur tous les hôtels du Grand Parc du Puy du Fou.' }
      ]
    }
  ],

  // ===============================================
  // TRAJETS VERS NANTES CENTRE
  // ===============================================
  nantes: [
    {
      slug: 'vtc-saint-nazaire-nantes',
      from: 'Saint-Nazaire',
      to: 'Nantes Centre',
      title: 'VTC Saint-Nazaire Nantes - Chauffeur Privé | Réservation Goloire-Cab au 02 59 22 20 00',
      metaDescription: 'VTC Saint-Nazaire ↔ Nantes Centre ⚡ Liaison premium 24/7 🚗 Prix fixe 120€ ✓ Gare SNCF ✓ CHU ✓ Réservez votre chauffeur privé !',
      keywords: 'vtc saint nazaire nantes, chauffeur prive saint nazaire nantes, navette saint nazaire nantes, transport saint nazaire nantes',
      heroImage: 'https://images.unsplash.com/photo-1449965408869-eaa3f722e40d?w=1920&q=80&fm=webp',
      distance: '60 km',
      duration: '45 min',
      price: 'dès 120€',
      priceReturn: 'dès 230€',
      fromCoords: { lat: 47.2730, lng: -2.2137 },
      toCoords: { lat: 47.2184, lng: -1.5536 },
      highlights: [
        'Liaison directe estuaire',
        'Desserte gare SNCF Nantes',
        'Accès centre historique',
        'Service professionnel',
        'Tarif fixe garanti',
        'Disponible 24h/24'
      ],
      description: `Service VTC premium entre Saint-Nazaire et Nantes Centre. Goloire-Cab assure la liaison entre les deux grandes villes de l'estuaire de la Loire. Idéal pour vos déplacements professionnels, rendez-vous médicaux au CHU, ou sorties culturelles. Nos chauffeurs connaissent parfaitement les deux villes.`,
      faq: [
        {
          question: 'Combien coûte un VTC Saint-Nazaire Nantes ?',
          answer: 'Le trajet VTC Saint-Nazaire vers Nantes Centre est à 120€ en tarif fixe.'
        },
        {
          question: 'Où pouvez-vous me déposer à Nantes ?',
          answer: 'Nous vous déposons à l\'adresse exacte de votre choix : gare SNCF, CHU, centre historique, quartier d\'affaires...'
        }
      ]
    },
    {
      slug: 'vtc-la-baule-nantes',
      from: 'La Baule',
      to: 'Nantes Centre',
      title: 'VTC La Baule Nantes - Chauffeur Privé | Réservation Goloire-Cab au 02 59 22 20 00',
      metaDescription: 'VTC La Baule ↔ Nantes Centre ⭐ Service haut de gamme 🚗 Prix fixe 120€ ✓ Tesla ✓ Confort 5 étoiles ✓ Réservez !',
      keywords: 'vtc la baule nantes, chauffeur prive la baule nantes, transport la baule nantes',
      heroImage: 'https://images.unsplash.com/photo-1449965408869-eaa3f722e40d?w=1920&q=80&fm=webp',
      distance: '75 km',
      duration: '1h00',
      price: 'dès 120€',
      priceReturn: 'dès 230€',
      fromCoords: { lat: 47.2861, lng: -2.3933 },
      toCoords: { lat: 47.2184, lng: -1.5536 },
      highlights: [
        'Liaison côte d\'Amour - Nantes',
        'Service luxe Tesla',
        'Prise en charge hôtels',
        'Événements & sorties',
        'Chauffeur professionnel'
      ],
      description: `VTC premium La Baule vers Nantes Centre. Profitez d'un service haut de gamme pour relier la station balnéaire à la métropole nantaise. Idéal pour le shopping, spectacles, rendez-vous d'affaires ou médicaux.`,
      faq: []
    },
    {
      slug: 'vtc-pornic-nantes',
      from: 'Pornic',
      to: 'Nantes Centre',
      title: 'VTC Pornic Nantes - Chauffeur Privé | Réservation Goloire-Cab au 02 59 22 20 00',
      metaDescription: 'VTC Pornic ↔ Nantes Centre ⚡ Service premium 🚗 Prix fixe 110€ ✓ Côte de Jade ✓ Réservez !',
      keywords: 'vtc pornic nantes, chauffeur prive pornic nantes, transport pornic nantes',
      heroImage: 'https://images.unsplash.com/photo-1449965408869-eaa3f722e40d?w=1920&q=80&fm=webp',
      distance: '50 km',
      duration: '45 min',
      price: 'dès 110€',
      priceReturn: 'dès 210€',
      fromCoords: { lat: 47.1167, lng: -2.1000 },
      toCoords: { lat: 47.2184, lng: -1.5536 },
      highlights: [
        'Liaison Côte de Jade',
        'Service toute l\'année',
        'Prise en charge domicile',
        'Tarif fixe'
      ],
      description: `Service VTC Pornic vers Nantes Centre. Liaison confortable depuis la Côte de Jade vers la métropole nantaise.`,
      faq: []
    },
    {
      slug: 'vtc-guerande-nantes',
      from: 'Guérande',
      to: 'Nantes Centre',
      title: 'VTC Guérande Nantes - Chauffeur Privé | Réservation Goloire-Cab au 02 59 22 20 00',
      metaDescription: 'VTC Guérande ↔ Nantes Centre ⚡ Chauffeur privé 🚗 Prix fixe 160€ ✓ Cité médiévale ✓ Réservez !',
      keywords: 'vtc guerande nantes, chauffeur prive guerande nantes, transport guerande nantes',
      heroImage: 'https://images.unsplash.com/photo-1449965408869-eaa3f722e40d?w=1920&q=80&fm=webp',
      distance: '70 km',
      duration: '55 min',
      price: 'dès 160€',
      priceReturn: 'dès 305€',
      fromCoords: { lat: 47.3278, lng: -2.4297 },
      toCoords: { lat: 47.2184, lng: -1.5536 },
      highlights: [
        'Cité médiévale - Métropole',
        'Service premium',
        'Marais salants',
        'Tourisme & affaires'
      ],
      description: `VTC Guérande vers Nantes Centre. Liaison premium entre la cité médiévale et la métropole nantaise.`,
      faq: []
    },
    {
      slug: 'vtc-clisson-nantes',
      from: 'Clisson',
      to: 'Nantes Centre',
      title: 'VTC Clisson Nantes - Chauffeur Privé | Réservation Goloire-Cab au 02 59 22 20 00',
      metaDescription: 'VTC Clisson ↔ Nantes Centre ⚡ Service vignoble 🚗 Prix fixe 60€ ✓ Château de Clisson ✓ Réservez !',
      keywords: 'vtc clisson nantes, chauffeur prive clisson nantes, transport clisson nantes',
      heroImage: 'https://images.unsplash.com/photo-1449965408869-eaa3f722e40d?w=1920&q=80&fm=webp',
      distance: '28 km',
      duration: '30 min',
      price: 'dès 60€',
      priceReturn: 'dès 115€',
      fromCoords: { lat: 47.0872, lng: -1.2828 },
      toCoords: { lat: 47.2184, lng: -1.5536 },
      highlights: [
        'Cœur du vignoble',
        'Château de Clisson',
        'Service œnotourisme',
        'Tarif attractif'
      ],
      description: `VTC Clisson vers Nantes Centre. Liaison directe depuis le cœur du vignoble nantais et le château de Clisson.`,
      faq: []
    },
    {
      slug: 'vtc-ancenis-nantes',
      from: 'Ancenis',
      to: 'Nantes Centre',
      title: 'VTC Ancenis Nantes - Chauffeur Privé | Réservation Goloire-Cab au 02 59 22 20 00',
      metaDescription: 'VTC Ancenis ↔ Nantes Centre ⚡ Service est Loire-Atlantique 🚗 Prix fixe 100€ ✓ Réservez !',
      keywords: 'vtc ancenis nantes, chauffeur prive ancenis nantes, transport ancenis nantes',
      heroImage: 'https://images.unsplash.com/photo-1449965408869-eaa3f722e40d?w=1920&q=80&fm=webp',
      distance: '40 km',
      duration: '35 min',
      price: 'dès 100€',
      priceReturn: 'dès 190€',
      fromCoords: { lat: 47.3667, lng: -1.1833 },
      toCoords: { lat: 47.2184, lng: -1.5536 },
      highlights: [
        'Est Loire-Atlantique',
        'Bords de Loire',
        'Service professionnel',
        'Disponible 24/7'
      ],
      description: `VTC Ancenis vers Nantes Centre. Service de chauffeur privé depuis l'est de la Loire-Atlantique.`,
      faq: []
    },
    {
      slug: 'vtc-chateaubriant-nantes',
      from: 'Châteaubriant',
      to: 'Nantes Centre',
      title: 'VTC Châteaubriant Nantes - Chauffeur Privé | Réservation Goloire-Cab au 02 59 22 20 00',
      metaDescription: 'VTC Châteaubriant ↔ Nantes Centre ⚡ Service nord Loire-Atlantique 🚗 Prix fixe 145€ ✓ Réservez !',
      keywords: 'vtc chateaubriant nantes, chauffeur prive chateaubriant nantes, transport chateaubriant nantes',
      heroImage: 'https://images.unsplash.com/photo-1449965408869-eaa3f722e40d?w=1920&q=80&fm=webp',
      distance: '60 km',
      duration: '50 min',
      price: 'dès 145€',
      priceReturn: 'dès 275€',
      fromCoords: { lat: 47.7167, lng: -1.3750 },
      toCoords: { lat: 47.2184, lng: -1.5536 },
      highlights: [
        'Nord Loire-Atlantique',
        'Château Renaissance',
        'Service régulier',
        'Tarif fixe'
      ],
      description: `VTC Châteaubriant vers Nantes Centre. Liaison depuis le nord du département vers la métropole.`,
      faq: []
    },
    {
      slug: 'vtc-challans-nantes',
      from: 'Challans',
      to: 'Nantes Centre',
      title: 'VTC Challans Nantes - Chauffeur Privé | Réservation Goloire-Cab au 02 59 22 20 00',
      metaDescription: 'VTC Challans ↔ Nantes Centre ⚡ Service Vendée 🚗 Prix fixe 150€ ✓ Réservez !',
      keywords: 'vtc challans nantes, chauffeur prive challans nantes, transport challans nantes',
      heroImage: 'https://images.unsplash.com/photo-1449965408869-eaa3f722e40d?w=1920&q=80&fm=webp',
      distance: '60 km',
      duration: '50 min',
      price: 'dès 150€',
      priceReturn: 'dès 280€',
      fromCoords: { lat: 46.8467, lng: -1.8783 },
      toCoords: { lat: 47.2184, lng: -1.5536 },
      highlights: [
        'Nord Vendée',
        'Marais breton',
        'Service inter-département',
        'Véhicules premium'
      ],
      description: `VTC Challans (Vendée) vers Nantes Centre. Liaison inter-départementale premium.`,
      faq: []
    },
    {
      slug: 'vtc-noirmoutier-nantes',
      from: 'Noirmoutier',
      to: 'Nantes Centre',
      title: 'VTC Noirmoutier Nantes - Chauffeur Privé | Réservation Goloire-Cab au 02 59 22 20 00',
      metaDescription: 'VTC Île de Noirmoutier ↔ Nantes Centre ⚡ Service insulaire 🚗 Prix fixe 195€ ✓ Réservez !',
      keywords: 'vtc noirmoutier nantes, chauffeur prive noirmoutier nantes, transport noirmoutier nantes',
      heroImage: 'https://images.unsplash.com/photo-1449965408869-eaa3f722e40d?w=1920&q=80&fm=webp',
      distance: '80 km',
      duration: '1h10',
      price: 'dès 195€',
      priceReturn: 'dès 365€',
      fromCoords: { lat: 46.9983, lng: -2.2450 },
      toCoords: { lat: 47.2184, lng: -1.5536 },
      highlights: [
        'Île de Noirmoutier',
        'Passage Gois ou pont',
        'Service touristique',
        'Confort premium'
      ],
      description: `VTC Île de Noirmoutier vers Nantes Centre. Service adapté aux contraintes insulaires.`,
      faq: []
    },
    {
      slug: 'vtc-les-sables-dolonne-nantes',
      from: 'Les Sables-d\'Olonne',
      to: 'Nantes Centre',
      title: 'VTC Les Sables-d\'Olonne Nantes | Goloire-Cab',
      metaDescription: 'VTC Les Sables-d\'Olonne ↔ Nantes Centre ⚡ Service Vendée 🚗 Prix fixe 215€ ✓ Réservez !',
      keywords: 'vtc les sables dolonne nantes, transport sables olonne nantes',
      heroImage: 'https://images.unsplash.com/photo-1449965408869-eaa3f722e40d?w=1920&q=80&fm=webp',
      distance: '95 km',
      duration: '1h15',
      price: 'dès 215€',
      priceReturn: 'dès 410€',
      fromCoords: { lat: 46.4967, lng: -1.7850 },
      toCoords: { lat: 47.2184, lng: -1.5536 },
      highlights: [
        'Vendée Globe',
        'Station balnéaire',
        'Service premium',
        'Longue distance'
      ],
      description: `VTC Les Sables-d'Olonne vers Nantes Centre. Liaison premium depuis la capitale du Vendée Globe.`,
      faq: []
    },
    // ===== ANGERS - MAINE-ET-LOIRE (49) =====
    {
      slug: 'vtc-angers-nantes',
      from: 'Angers',
      to: 'Nantes Centre',
      title: 'VTC Angers Nantes - Chauffeur Privé | Réservation Goloire-Cab au 02 59 22 20 00',
      metaDescription: 'VTC Angers ↔ Nantes Centre ⚡ Capitale de l\'Anjou 🚗 Prix fixe 190€ ✓ Alternative au TGV ✓ Porte-à-porte ✓ Réservez !',
      keywords: 'vtc angers nantes, chauffeur privé angers nantes, transport angers nantes, navette angers nantes, taxi angers nantes',
      heroImage: 'https://images.unsplash.com/photo-1449965408869-eaa3f722e40d?w=1920&q=80&fm=webp',
      distance: '90 km',
      duration: '1h05',
      price: 'dès 190€',
      priceReturn: 'dès 360€',
      fromCoords: { lat: 47.4784, lng: -0.5632 },
      toCoords: { lat: 47.2184, lng: -1.5536 },
      highlights: [
        'Capitale de l\'Anjou vers Nantes',
        'Alternative confortable au TGV',
        'Service porte-à-porte',
        'Idéal rendez-vous professionnels',
        'Châteaux de la Loire à proximité',
        'Véhicules premium'
      ],
      description: `Service VTC premium entre Angers et Nantes Centre. Alternative confortable au TGV (40 min) pour un service porte-à-porte sans correspondance. Idéal pour les rendez-vous professionnels, les visites médicales au CHU de Nantes, ou les excursions entre les deux capitales régionales.`,
      faq: [
        {
          question: 'Le VTC est-il plus pratique que le TGV Angers-Nantes ?',
          answer: 'Le TGV est plus rapide (40 min) mais le VTC offre un service porte-à-porte sans correspondance. Pour 2-3 personnes, le VTC est souvent plus économique et pratique.'
        },
        {
          question: 'Combien coûte un VTC Angers-Nantes ?',
          answer: 'Le transfert VTC Angers-Nantes est à 190€ en tarif fixe tout compris. Pour plusieurs passagers, c\'est très compétitif.'
        }
      ]
    },
    // ===== RENNES - ILLE-ET-VILAINE (35) =====
    {
      slug: 'vtc-rennes-nantes',
      from: 'Rennes',
      to: 'Nantes Centre',
      title: 'VTC Rennes Nantes - Chauffeur Privé | Réservation Goloire-Cab au 02 59 22 20 00',
      metaDescription: 'VTC Rennes ↔ Nantes Centre ⚡ Capitales bretonnes 🚗 Prix fixe 260€ ✓ Alternative au TGV ✓ Porte-à-porte ✓ Réservez !',
      keywords: 'vtc rennes nantes, chauffeur privé rennes nantes, transport rennes nantes, navette rennes nantes, taxi rennes nantes',
      heroImage: 'https://images.unsplash.com/photo-1449965408869-eaa3f722e40d?w=1920&q=80&fm=webp',
      distance: '110 km',
      duration: '1h15',
      price: 'dès 260€',
      priceReturn: 'dès 495€',
      fromCoords: { lat: 48.1173, lng: -1.6778 },
      toCoords: { lat: 47.2184, lng: -1.5536 },
      highlights: [
        'Liaison entre capitales bretonnes',
        'Alternative confortable au TGV',
        'Service porte-à-porte',
        'Idéal voyageurs d\'affaires',
        'Connexion Bretagne-Pays de la Loire',
        'Véhicules premium'
      ],
      description: `Service VTC premium entre Rennes et Nantes, les deux grandes métropoles du Grand Ouest. Alternative au TGV (1h15) pour un service porte-à-porte sans correspondance. Idéal pour les déplacements professionnels entre les pôles économiques bretons et ligériens.`,
      faq: [
        {
          question: 'Le VTC est-il compétitif face au TGV Rennes-Nantes ?',
          answer: 'Le TGV met environ 1h15 mais nécessite de rejoindre les gares. Le VTC offre un service porte-à-porte. Pour 2-4 personnes voyageant ensemble, le VTC est souvent plus avantageux.'
        },
        {
          question: 'Combien coûte un VTC Rennes-Nantes ?',
          answer: 'Le transfert VTC Rennes-Nantes est à 260€ en tarif fixe tout compris. Idéal pour les déplacements professionnels ou les familles.'
        }
      ]
    },
    // ===== VANNES - MORBIHAN (56) =====
    {
      slug: 'vtc-vannes-nantes',
      from: 'Vannes',
      to: 'Nantes Centre',
      title: 'VTC Vannes Nantes - Chauffeur Privé | Réservation Goloire-Cab au 02 59 22 20 00',
      metaDescription: 'VTC Vannes ↔ Nantes Centre ⚡ Golfe du Morbihan 🚗 Prix fixe 280€ ✓ Alternative au TER ✓ Porte-à-porte ✓ Réservez !',
      keywords: 'vtc vannes nantes, chauffeur privé vannes nantes, transport vannes nantes, navette vannes nantes, taxi vannes nantes',
      heroImage: 'https://images.unsplash.com/photo-1449965408869-eaa3f722e40d?w=1920&q=80&fm=webp',
      distance: '115 km',
      duration: '1h20',
      price: 'dès 280€',
      priceReturn: 'dès 540€',
      fromCoords: { lat: 47.6559, lng: -2.7603 },
      toCoords: { lat: 47.2184, lng: -1.5536 },
      highlights: [
        'Golfe du Morbihan vers Nantes',
        'Alternative confortable au TER',
        'Service porte-à-porte',
        'Idéal touristes et résidents',
        'Pas de correspondance',
        'Véhicules premium'
      ],
      description: `Service VTC premium entre Vannes et Nantes Centre. Alternative au TER (1h30 avec correspondances) pour un service direct et confortable. Idéal pour les touristes du Golfe du Morbihan, les résidents secondaires, et les professionnels.`,
      faq: [
        {
          question: 'Le VTC est-il plus rapide que le train Vannes-Nantes ?',
          answer: 'Le TER met environ 1h30 avec souvent une correspondance à Redon. Le VTC vous emmène directement à votre destination en 1h20, sans stress de correspondance.'
        },
        {
          question: 'Combien coûte un VTC Vannes-Nantes ?',
          answer: 'Le transfert VTC Vannes-Nantes est à 280€ en tarif fixe tout compris. Pour 2-3 personnes, c\'est très compétitif face aux billets TER.'
        }
      ]
    },
    // =====================================================
    // NOUVEAUX TRAJETS NANTES CENTRE (avril 2026)
    // =====================================================
    {
      slug: 'vtc-tours-nantes',
      from: 'Tours',
      to: 'Nantes Centre',
      title: 'VTC Tours Nantes - Chauffeur Privé Val de Loire | Goloire-Cab',
      metaDescription: 'VTC Tours ↔ Nantes Centre ⭐ 205 km, 2h 🚗 Liaison directe Val de Loire ✓ Prix fixe dès 300€ ✓ Tesla premium ✓ 24h/24.',
      keywords: 'vtc tours nantes, chauffeur prive tours nantes, transport tours nantes, navette tours nantes gare',
      heroImage: 'https://images.unsplash.com/photo-1449965408869-eaa3f722e40d?w=1920&q=80&fm=webp',
      distance: '205 km', duration: '2h', price: 'dès 300€', priceReturn: 'dès 540€',
      fromCoords: { lat: 47.3941, lng: 0.6848 }, toCoords: { lat: 47.2184, lng: -1.5536 },
      highlights: [
        'Liaison Val de Loire ↔ Loire-Atlantique',
        'Autoroute A85 + A11 via Angers',
        'Desserte Gare SNCF Nantes & CHU',
        'Service professionnel business',
        'Véhicules Tesla longue distance confortables'
      ],
      description: `VTC premium Tours vers Nantes Centre. Liaison A85/A11 via Angers (205 km, 2h). Idéal pour déplacements professionnels, rendez-vous médicaux au CHU Nantes, événements culturels. Prise en charge Tours centre-ville, gare TGV Saint-Pierre-des-Corps, hôtels.`,
      faq: [
        { question: 'Prix VTC Tours → Nantes ?', answer: 'Tarif fixe dès 300€ pour le trajet simple (205 km, 2h). Aller-retour possible à 540€.' }
      ]
    },
    {
      slug: 'vtc-saumur-nantes',
      from: 'Saumur',
      to: 'Nantes Centre',
      title: 'VTC Saumur Nantes - Chauffeur Privé Val de Loire | Goloire-Cab',
      metaDescription: 'VTC Saumur ↔ Nantes Centre ⭐ 130 km, 1h25 🚗 Val de Loire premium ✓ Prix fixe dès 185€ ✓ Desserte domaines viticoles ✓ 24h/24.',
      keywords: 'vtc saumur nantes, chauffeur prive saumur nantes, transport saumur nantes, navette val de loire nantes',
      heroImage: 'https://images.unsplash.com/photo-1449965408869-eaa3f722e40d?w=1920&q=80&fm=webp',
      distance: '130 km', duration: '1h25', price: 'dès 185€', priceReturn: 'dès 335€',
      fromCoords: { lat: 47.2598, lng: -0.0738 }, toCoords: { lat: 47.2184, lng: -1.5536 },
      highlights: [
        'Autoroute A85 directe',
        'Desserte domaines viticoles AOC Saumur',
        'Prise en charge château, gare SNCF, Cadre Noir',
        'Service bilingue pour touristes',
        'Véhicules Tesla haut de gamme'
      ],
      description: `VTC Saumur vers Nantes Centre. Liaison A85 (130 km, 1h25). Desserte du château de Saumur, Cadre Noir de l'École Nationale d'Équitation, troglodytes et domaines viticoles AOC Saumur-Champigny.`,
      faq: [
        { question: 'Prix VTC Saumur → Nantes ?', answer: 'Tarif fixe dès 185€ tout compris (130 km, 1h25). Aller-retour 335€.' }
      ]
    },
    {
      slug: 'vtc-la-roche-sur-yon-nantes',
      from: 'La Roche-sur-Yon',
      to: 'Nantes Centre',
      title: 'VTC La Roche-sur-Yon Nantes - Chauffeur Privé Vendée | Goloire-Cab',
      metaDescription: 'VTC La Roche-sur-Yon ↔ Nantes Centre ⭐ 65 km, 50 min 🚗 Préfecture Vendée ✓ Prix fixe dès 95€ ✓ 24h/24.',
      keywords: 'vtc la roche sur yon nantes, chauffeur prive la roche nantes, transport la roche sur yon nantes',
      heroImage: 'https://images.unsplash.com/photo-1449965408869-eaa3f722e40d?w=1920&q=80&fm=webp',
      distance: '65 km', duration: '50 min', price: 'dès 95€', priceReturn: 'dès 175€',
      fromCoords: { lat: 46.6704, lng: -1.4264 }, toCoords: { lat: 47.2184, lng: -1.5536 },
      highlights: [
        'Liaison A83 directe',
        'Préfecture Vendée ↔ Métropole Nantes',
        'Desserte gare SNCF Nantes & CHU',
        'Déplacement business Vendéspace',
        'Service 24h/24'
      ],
      description: `VTC La Roche-sur-Yon vers Nantes Centre. Liaison rapide A83 (65 km, 50 min). Idéal pour déplacements professionnels, visites CHU Nantes, événements au Vendéspace.`,
      faq: [
        { question: 'Prix VTC La Roche-sur-Yon → Nantes ?', answer: 'Tarif fixe dès 95€ (65 km, 50 min). Aller-retour 175€.' }
      ]
    },
    {
      slug: 'vtc-saint-gilles-croix-de-vie-nantes',
      from: 'Saint-Gilles-Croix-de-Vie',
      to: 'Nantes Centre',
      title: 'VTC Saint-Gilles-Croix-de-Vie Nantes - Chauffeur Privé | Goloire-Cab',
      metaDescription: 'VTC Saint-Gilles-Croix-de-Vie ↔ Nantes Centre ⭐ 75 km, 1h 🚗 Côte vendéenne ✓ Prix fixe dès 120€ ✓ 24h/24.',
      keywords: 'vtc saint gilles croix de vie nantes, transport saint gilles nantes, chauffeur prive cote vendeenne nantes',
      heroImage: 'https://images.unsplash.com/photo-1449965408869-eaa3f722e40d?w=1920&q=80&fm=webp',
      distance: '75 km', duration: '1h', price: 'dès 120€', priceReturn: 'dès 215€',
      fromCoords: { lat: 46.6942, lng: -1.9419 }, toCoords: { lat: 47.2184, lng: -1.5536 },
      highlights: [
        'Port de pêche ↔ Nantes Centre',
        'Desserte hôtels et résidences de tourisme',
        'Shopping, spectacles, CHU',
        'Service saisonnier + annuel',
        'Véhicules confortables 4 pax'
      ],
      description: `VTC Saint-Gilles-Croix-de-Vie vers Nantes Centre. Liaison rapide (75 km, 1h) idéale pour shopping, spectacles et visites médicales au CHU. Prise en charge hôtels front de mer, casino et résidences de tourisme.`,
      faq: [
        { question: 'Prix VTC Saint-Gilles → Nantes ?', answer: 'Tarif fixe dès 120€ (75 km, 1h). Aller-retour 215€.' }
      ]
    },
    {
      slug: 'vtc-saint-hilaire-de-riez-nantes',
      from: 'Saint-Hilaire-de-Riez',
      to: 'Nantes Centre',
      title: 'VTC Saint-Hilaire-de-Riez Nantes - Chauffeur Privé | Goloire-Cab',
      metaDescription: 'VTC Saint-Hilaire-de-Riez ↔ Nantes Centre ⭐ 75 km, 1h 🚗 Sion-sur-l\'Océan ✓ Prix fixe dès 120€ ✓ 24h/24.',
      keywords: 'vtc saint hilaire de riez nantes, transport saint hilaire nantes, chauffeur prive sion ocean nantes',
      heroImage: 'https://images.unsplash.com/photo-1449965408869-eaa3f722e40d?w=1920&q=80&fm=webp',
      distance: '75 km', duration: '1h', price: 'dès 120€', priceReturn: 'dès 215€',
      fromCoords: { lat: 46.7208, lng: -1.9444 }, toCoords: { lat: 47.2184, lng: -1.5536 },
      highlights: [
        'Station balnéaire ↔ Nantes Centre',
        'Desserte campings 4/5★ & villas',
        'Sion-sur-l\'Océan, plages des Mouettes',
        'Shopping Nantes, spectacles, CHU',
        'Service 7j/7 haute saison'
      ],
      description: `VTC Saint-Hilaire-de-Riez vers Nantes Centre. Prise en charge campings (Les Ecureuils, Les Biches, La Yole), villas et résidences Sion-sur-l'Océan. Idéal pour journée shopping ou spectacles à Nantes.`,
      faq: [
        { question: 'Prix VTC Saint-Hilaire-de-Riez → Nantes ?', answer: 'Tarif fixe dès 120€ (75 km, 1h).' }
      ]
    }
  ],

  // ===============================================
  // TRAJETS VERS LE PUY DU FOU
  // ===============================================
  puydufou: [
    {
      slug: 'vtc-cholet-puy-du-fou',
      from: 'Cholet',
      to: 'Puy du Fou',
      title: 'VTC Cholet Puy du Fou - Chauffeur Privé | Réservation Goloire-Cab au 02 59 22 20 00',
      metaDescription: 'Transfert VTC Cholet ↔ Puy du Fou ⚡ À seulement 30 min 🎭 Prix fixe 95€ ✓ Service famille & groupes ✓ Meilleur parc du monde ✓ Réservez !',
      keywords: 'vtc cholet puy du fou, transfert cholet puy du fou, navette cholet puy du fou, taxi cholet puy du fou, chauffeur privé puy du fou',
      heroImage: 'https://images.unsplash.com/photo-1671572990341-31584046103d?w=1920&q=80&fm=webp',
      distance: '30 km',
      duration: '30 min',
      price: 'dès 95€',
      priceReturn: 'dès 175€',
      fromCoords: { lat: 47.0601, lng: -0.8788 },
      toCoords: { lat: 46.8897, lng: -0.9306 },
      highlights: [
        'Trajet le plus court vers le Puy du Fou',
        'À seulement 30 minutes de Cholet',
        'Idéal pour les familles et groupes',
        'Aller-retour journée disponible',
        'Dépôt à l\'entrée du parc',
        'Service Cinéscénie disponible',
        'Véhicules spacieux pour familles'
      ],
      description: `Service de transfert VTC entre Cholet et le Puy du Fou, le meilleur parc du monde. Depuis Cholet, le trajet ne dure que 30 minutes, ce qui fait de la capitale des Mauges le point de départ idéal pour visiter le parc. 

Goloire-Cab propose des formules adaptées : aller simple pour rejoindre votre hôtel au Grand Parc, aller-retour journée pour profiter des spectacles, ou service spécial Cinéscénie avec retour tardif. Nos véhicules Tesla et Kia EV6 sont parfaits pour les familles avec enfants.

Pour les visiteurs arrivant en TGV à la gare de Cholet, nous assurons le relais vers le Puy du Fou. Un service premium pour une expérience inoubliable au parc le plus récompensé au monde.`,
      faq: [
        {
          question: 'Combien coûte un VTC Cholet Puy du Fou ?',
          answer: 'Le transfert VTC Cholet vers le Puy du Fou est à 95€ l\'aller simple. Nous proposons aussi une formule aller-retour journée à 95€ avec attente pendant votre visite.'
        },
        {
          question: 'Combien de temps dure le trajet Cholet Puy du Fou ?',
          answer: 'Le trajet Cholet-Puy du Fou dure seulement 30 minutes via la D752 et la D27. C\'est le trajet le plus court depuis une grande ville.'
        },
        {
          question: 'Proposez-vous un service pour la Cinéscénie ?',
          answer: 'Oui, nous proposons un service spécial Cinéscénie avec retour tardif (fin du spectacle vers minuit). Tarif sur devis selon l\'horaire de retour.'
        },
        {
          question: 'Pouvez-vous transporter une famille avec enfants ?',
          answer: 'Absolument ! Nos véhicules accueillent jusqu\'à 4 passagers avec bagages. Sièges enfants disponibles sur demande lors de la réservation.'
        },
        {
          question: 'Puis-je réserver un aller-retour pour la journée ?',
          answer: 'Oui, notre formule journée à 95€ inclut l\'aller le matin, l\'attente (ou retour et reprise), et le retour à Cholet en fin de journée.'
        }
      ]
    },
    {
      slug: 'vtc-nantes-puy-du-fou',
      from: 'Nantes',
      to: 'Puy du Fou',
      title: 'VTC Nantes Puy du Fou - Chauffeur Privé | Réservation Goloire-Cab au 02 59 22 20 00',
      metaDescription: 'Transfert VTC Nantes ↔ Puy du Fou ⚡ 1h15 de trajet 🎭 Prix fixe 205€ ✓ Meilleur parc du monde ✓ Cinéscénie ✓ Réservez votre chauffeur !',
      keywords: 'vtc nantes puy du fou, transfert nantes puy du fou, navette nantes puy du fou, excursion puy du fou nantes',
      heroImage: 'https://images.unsplash.com/photo-1671572990341-31584046103d?w=1920&q=80&fm=webp',
      distance: '95 km',
      duration: '1h15',
      price: 'dès 205€',
      priceReturn: 'dès 365€',
      fromCoords: { lat: 47.2184, lng: -1.5536 },
      toCoords: { lat: 46.8897, lng: -0.9306 },
      highlights: [
        'Excursion depuis Nantes',
        'Service porte-à-porte',
        'Formule journée complète',
        'Service Cinéscénie disponible',
        'Véhicules confortables',
        'Chauffeurs connaissant le parc'
      ],
      description: `Transfert VTC premium entre Nantes et le Puy du Fou. Profitez d'une excursion confortable vers le meilleur parc du monde depuis Nantes. Service aller simple, journée ou Cinéscénie.`,
      faq: [
        {
          question: 'Combien de temps pour aller de Nantes au Puy du Fou ?',
          answer: 'Le trajet Nantes-Puy du Fou dure environ 1h15 via l\'A87 et la D752.'
        },
        {
          question: 'Proposez-vous des excursions à la journée ?',
          answer: 'Oui, notre formule journée inclut l\'aller le matin, l\'attente, et le retour en fin de journée. Tarif sur devis.'
        }
      ]
    },
    {
      slug: 'vtc-aeroport-puy-du-fou',
      from: 'Aéroport Nantes',
      to: 'Puy du Fou',
      title: 'VTC Aéroport Nantes Puy du Fou - Chauffeur Privé | Goloire-Cab',
      metaDescription: 'Transfert VTC Aéroport Nantes ↔ Puy du Fou ⚡ Direct depuis l\'aéroport 🎭 Prix fixe 240€ ✓ Suivi des vols ✓ Réservez !',
      keywords: 'vtc aeroport nantes puy du fou, transfert aeroport puy du fou, navette aeroport puy du fou',
      heroImage: 'https://images.unsplash.com/photo-1671572990341-31584046103d?w=1920&q=80&fm=webp',
      distance: '100 km',
      duration: '1h20',
      price: 'dès 240€',
      priceReturn: 'dès 430€',
      fromCoords: { lat: 47.1531, lng: -1.6108 },
      toCoords: { lat: 46.8897, lng: -0.9306 },
      highlights: [
        'Transfert direct aéroport-parc',
        'Suivi des vols en temps réel',
        'Attente gratuite retards',
        'Service premium',
        'Idéal touristes internationaux'
      ],
      description: `Transfert VTC direct entre l'Aéroport Nantes Atlantique et le Puy du Fou. Service idéal pour les touristes arrivant par avion et souhaitant rejoindre directement le parc.`,
      faq: []
    },
    // ===== TRAJETS DEPUIS GARE SNCF CHOLET =====
    {
      slug: 'vtc-gare-cholet-puy-du-fou',
      from: 'Gare SNCF Cholet',
      to: 'Puy du Fou',
      title: 'VTC Gare Cholet Puy du Fou - Chauffeur Privé | Réservation Goloire-Cab au 02 59 22 20 00',
      metaDescription: 'Transfert VTC Gare SNCF Cholet ↔ Puy du Fou ⚡ À 30 min du TGV 🎭 Prix fixe 95€ ✓ Correspondance TGV Paris ✓ Meilleur parc du monde ✓ Réservez !',
      keywords: 'vtc gare cholet puy du fou, navette gare cholet puy du fou, transfert tgv cholet puy du fou, correspondance train puy du fou',
      heroImage: 'https://images.unsplash.com/photo-1671572990341-31584046103d?w=1920&q=80&fm=webp',
      distance: '30 km',
      duration: '30 min',
      price: 'dès 95€',
      priceReturn: 'dès 175€',
      fromCoords: { lat: 47.0590, lng: -0.8820 },
      toCoords: { lat: 46.8897, lng: -0.9306 },
      highlights: [
        'Correspondance TGV Paris-Cholet',
        'À seulement 30 min du Puy du Fou',
        'Accueil sur le quai de la gare',
        'Suivi des horaires SNCF en temps réel',
        'Attente gratuite en cas de retard train',
        'Panneau nominatif à l\'arrivée',
        'Service Cinéscénie avec retour tardif'
      ],
      description: `Service VTC de correspondance entre la Gare SNCF de Cholet et le Puy du Fou. Idéal pour les voyageurs arrivant en TGV depuis Paris (3h de trajet) qui souhaitent rejoindre le meilleur parc du monde en seulement 30 minutes.

Goloire-Cab assure la liaison parfaite entre votre TGV et le Puy du Fou. Nos chauffeurs suivent les horaires SNCF en temps réel et s'adaptent aux éventuels retards sans frais supplémentaires. Vous êtes accueilli à votre descente de train avec un panneau nominatif.

Service disponible pour tous les trains : TGV Paris-Cholet, TER régionaux, et Intercités. Formules aller simple, aller-retour journée, ou service spécial Cinéscénie avec retour tardif vers la gare.`,
      faq: [
        {
          question: 'Comment fonctionne le transfert depuis la gare de Cholet ?',
          answer: 'Votre chauffeur vous attend à la sortie de la gare avec un panneau à votre nom. Nous suivons votre train en temps réel et nous adaptons à tout retard éventuel sans frais.'
        },
        {
          question: 'Combien de temps entre la gare de Cholet et le Puy du Fou ?',
          answer: 'Le trajet Gare SNCF Cholet vers le Puy du Fou dure seulement 30 minutes. C\'est la correspondance la plus rapide depuis Paris en TGV.'
        },
        {
          question: 'Quel est le prix du VTC Gare Cholet - Puy du Fou ?',
          answer: 'Le transfert est à 95€ l\'aller simple. Nous proposons aussi une formule aller-retour à 95€ pour récupérer à la fermeture du parc.'
        },
        {
          question: 'Puis-je réserver pour la Cinéscénie ?',
          answer: 'Oui, nous proposons un service spécial Cinéscénie. Nous vous déposons au parc et vous récupérons après le spectacle (fin vers minuit) pour vous ramener à la gare ou votre hôtel.'
        },
        {
          question: 'Y a-t-il des TGV directs Paris-Cholet ?',
          answer: 'Oui, plusieurs TGV relient Paris Montparnasse à Cholet en environ 3h. C\'est l\'option la plus pratique pour visiter le Puy du Fou depuis Paris en une journée.'
        }
      ]
    },
    {
      slug: 'vtc-gare-cholet-aeroport',
      from: 'Gare SNCF Cholet',
      to: 'Aéroport Nantes Atlantique',
      title: 'VTC Gare Cholet Aéroport Nantes - Chauffeur Privé | Réservation Goloire-Cab au 02 59 22 20 00',
      metaDescription: 'Transfert VTC Gare SNCF Cholet ↔ Aéroport Nantes ⚡ Correspondance TGV-Avion 🛫 Prix fixe 185€ ✓ Suivi des trains ✓ Réservez !',
      keywords: 'vtc gare cholet aeroport, navette gare cholet aeroport nantes, transfert tgv avion cholet, correspondance train avion nantes',
      heroImage: 'https://images.unsplash.com/photo-1436491865332-7a61a109cc05?w=1920&q=80&fm=webp',
      distance: '70 km',
      duration: '55 min',
      price: 'dès 185€',
      priceReturn: 'dès 345€',
      fromCoords: { lat: 47.0590, lng: -0.8820 },
      toCoords: { lat: 47.1531, lng: -1.6108 },
      highlights: [
        'Correspondance TGV → Avion optimale',
        'Accueil sur le quai de la gare',
        'Suivi horaires SNCF en temps réel',
        'Dépôt direct au terminal',
        'Plus rapide que TGV Nantes + navette',
        'Aide aux bagages incluse',
        'Service retour aéroport → gare disponible'
      ],
      description: `Service VTC de correspondance entre la Gare SNCF de Cholet et l'Aéroport Nantes Atlantique. Solution idéale pour les voyageurs en TGV depuis Paris qui doivent prendre un vol à Nantes, ou inversement.

Ce transfert direct de 55 minutes est plus rapide et plus confortable que la correspondance traditionnelle (TGV vers Nantes + tramway/navette vers l'aéroport qui prend environ 2h30 au total). Nos chauffeurs suivent les horaires SNCF et adaptent leur arrivée en cas de retard.

Pour les voyageurs arrivant par avion et souhaitant rejoindre Cholet ou le Puy du Fou, c'est également la solution la plus pratique : un seul transfert direct sans correspondance.`,
      faq: [
        {
          question: 'Pourquoi choisir le VTC plutôt que le TGV vers Nantes puis navette ?',
          answer: 'Le trajet Gare Cholet → Aéroport en VTC prend 55 min contre environ 2h30 via TGV Nantes + tramway/navette. C\'est plus rapide, plus confortable et sans stress de correspondance.'
        },
        {
          question: 'Combien coûte le transfert Gare Cholet - Aéroport Nantes ?',
          answer: 'Le transfert est à 185€ en tarif fixe tout compris, incluant l\'accueil à la gare, l\'aide aux bagages et le dépôt au terminal.'
        },
        {
          question: 'Pouvez-vous m\'attendre si mon train a du retard ?',
          answer: 'Oui, nous suivons les horaires SNCF en temps réel. En cas de retard de votre train, votre chauffeur ajuste son arrivée sans frais supplémentaires.'
        },
        {
          question: 'Proposez-vous le trajet inverse Aéroport → Gare Cholet ?',
          answer: 'Absolument ! Nous assurons les transferts Aéroport Nantes vers Gare SNCF Cholet avec suivi de vol et attente gratuite en cas de retard d\'avion.'
        }
      ]
    },
    {
      slug: 'vtc-gare-cholet-nantes',
      from: 'Gare SNCF Cholet',
      to: 'Nantes Centre',
      title: 'VTC Gare Cholet Nantes - Chauffeur Privé | Réservation Goloire-Cab au 02 59 22 20 00',
      metaDescription: 'Transfert VTC Gare SNCF Cholet ↔ Nantes Centre ⚡ Alternative au TER 🚗 Prix fixe 150€ ✓ Direct et confortable ✓ Réservez !',
      keywords: 'vtc gare cholet nantes, navette gare cholet nantes, transfert cholet nantes, alternative ter cholet nantes',
      heroImage: 'https://images.unsplash.com/photo-1449965408869-eaa3f722e40d?w=1920&q=80&fm=webp',
      distance: '60 km',
      duration: '50 min',
      price: 'dès 150€',
      priceReturn: 'dès 280€',
      fromCoords: { lat: 47.0590, lng: -0.8820 },
      toCoords: { lat: 47.2184, lng: -1.5536 },
      highlights: [
        'Alternative confortable au TER',
        'Trajet direct sans correspondance',
        'Accueil à la gare de Cholet',
        'Dépôt à l\'adresse exacte à Nantes',
        'Idéal pour rendez-vous professionnels',
        'Service porte-à-porte'
      ],
      description: `Service VTC entre la Gare SNCF de Cholet et Nantes Centre. Alternative confortable et directe au TER pour les voyageurs souhaitant rejoindre une adresse précise à Nantes sans correspondance ni transport en commun.

Idéal pour les professionnels en déplacement, les rendez-vous médicaux au CHU de Nantes, ou simplement pour un trajet plus confortable après un long voyage en TGV depuis Paris.`,
      faq: [
        {
          question: 'Quelle est la différence avec le TER Cholet-Nantes ?',
          answer: 'Le VTC vous dépose à l\'adresse exacte de votre choix à Nantes (CHU, centre d\'affaires, hôtel...) sans correspondance tramway/bus. Le trajet est aussi plus rapide (50 min vs 1h10 en TER).'
        },
        {
          question: 'Combien coûte le VTC Gare Cholet - Nantes ?',
          answer: 'Le transfert est à 150€ en tarif fixe, tout compris. Pour 2-3 personnes voyageant ensemble, c\'est souvent plus avantageux que les billets TER individuels.'
        }
      ]
    },
    // =====================================================
    // NOUVEAUX TRAJETS PUY DU FOU (avril 2026)
    // =====================================================
    {
      slug: 'vtc-tours-puy-du-fou',
      from: 'Tours',
      to: 'Puy du Fou',
      title: 'VTC Tours Puy du Fou - Transfert Val de Loire | Goloire-Cab',
      metaDescription: 'Transfert VTC Tours ↔ Puy du Fou ⭐ 145 km, 1h45 🎭 Meilleur parc du monde ✓ Prix fixe dès 235€ ✓ Familles & groupes ✓ Cinéscénie.',
      keywords: 'vtc tours puy du fou, transfert tours puy du fou, navette val de loire puy du fou, chauffeur prive puy du fou tours',
      heroImage: 'https://images.unsplash.com/photo-1671572990341-31584046103d?w=1920&q=80&fm=webp',
      distance: '145 km', duration: '1h45', price: 'dès 235€', priceReturn: 'dès 420€',
      fromCoords: { lat: 47.3941, lng: 0.6848 }, toCoords: { lat: 46.8897, lng: -0.9306 },
      highlights: [
        'Val de Loire ↔ Bocage Vendéen',
        'Prise en charge gare TGV Saint-Pierre-des-Corps',
        'Desserte hôtels Tours & Puy du Fou',
        'Formule Cinéscénie (retour tardif)',
        'Véhicules spacieux familles'
      ],
      description: `VTC Tours vers le Puy du Fou. Liaison via A85 (145 km, 1h45). Idéal pour les visiteurs TGV arrivant à Saint-Pierre-des-Corps souhaitant rejoindre le meilleur parc du monde. Formule Cinéscénie disponible avec retour tardif après le spectacle.`,
      faq: [
        { question: 'Prix VTC Tours → Puy du Fou ?', answer: 'Tarif fixe dès 235€ (145 km, 1h45). Formule aller-retour journée 420€.' },
        { question: 'Proposez-vous la formule Cinéscénie ?', answer: 'Oui, retour tardif possible après le spectacle (vers minuit). Tarif sur devis.' }
      ]
    },
    {
      slug: 'vtc-angers-puy-du-fou',
      from: 'Angers',
      to: 'Puy du Fou',
      title: 'VTC Angers Puy du Fou - Transfert Direct | Goloire-Cab',
      metaDescription: 'Transfert VTC Angers ↔ Puy du Fou ⭐ 80 km, 1h 🎭 Meilleur parc du monde ✓ Prix fixe dès 140€ ✓ Service familles ✓ Cinéscénie.',
      keywords: 'vtc angers puy du fou, transfert angers puy du fou, chauffeur prive angers puy du fou',
      heroImage: 'https://images.unsplash.com/photo-1671572990341-31584046103d?w=1920&q=80&fm=webp',
      distance: '80 km', duration: '1h', price: 'dès 140€', priceReturn: 'dès 250€',
      fromCoords: { lat: 47.4784, lng: -0.5632 }, toCoords: { lat: 46.8897, lng: -0.9306 },
      highlights: [
        'Trajet direct A87',
        'Prise en charge gare SNCF Angers Saint-Laud',
        'Formule journée aller-retour',
        'Service Cinéscénie (retour tardif)',
        'Idéal familles & groupes'
      ],
      description: `VTC Angers vers le Puy du Fou. Liaison A87 directe (80 km, 1h). Depuis la gare TGV Angers Saint-Laud ou les hôtels du centre-ville, rejoignez le meilleur parc du monde en toute sérénité.`,
      faq: [
        { question: 'Prix VTC Angers → Puy du Fou ?', answer: 'Tarif fixe dès 140€ (80 km, 1h). Formule aller-retour journée 250€.' }
      ]
    },
    {
      slug: 'vtc-les-sables-dolonne-puy-du-fou',
      from: 'Les Sables-d\'Olonne',
      to: 'Puy du Fou',
      title: 'VTC Les Sables-d\'Olonne Puy du Fou | Goloire-Cab',
      metaDescription: 'Transfert VTC Les Sables-d\'Olonne ↔ Puy du Fou ⭐ 85 km, 1h10 🎭 Meilleur parc du monde ✓ Prix fixe dès 150€ ✓ Familles ✓ Cinéscénie.',
      keywords: 'vtc les sables d olonne puy du fou, transfert les sables puy du fou, chauffeur prive vendee puy du fou',
      heroImage: 'https://images.unsplash.com/photo-1671572990341-31584046103d?w=1920&q=80&fm=webp',
      distance: '85 km', duration: '1h10', price: 'dès 150€', priceReturn: 'dès 270€',
      fromCoords: { lat: 46.4969, lng: -1.7842 }, toCoords: { lat: 46.8897, lng: -0.9306 },
      highlights: [
        'Côte Atlantique ↔ Bocage Vendéen',
        'Prise en charge hôtels front de mer',
        'Retour Remblai (vie nocturne)',
        'Service familles avec sièges enfants',
        'Formule Cinéscénie disponible'
      ],
      description: `VTC Les Sables-d'Olonne vers le Puy du Fou. Liaison directe (85 km, 1h10). Idéal pour les vacanciers de la côte vendéenne souhaitant découvrir le meilleur parc du monde. Prise en charge hôtels du Remblai, casino, résidences de tourisme.`,
      faq: [
        { question: 'Prix VTC Les Sables-d\'Olonne → Puy du Fou ?', answer: 'Tarif fixe dès 150€ (85 km, 1h10). Formule aller-retour 270€.' }
      ]
    },
    {
      slug: 'vtc-les-herbiers-puy-du-fou',
      from: 'Les Herbiers',
      to: 'Puy du Fou',
      title: 'VTC Les Herbiers Puy du Fou - 15 min | Goloire-Cab',
      metaDescription: 'Transfert VTC Les Herbiers ↔ Puy du Fou ⭐ 12 km, 15 min 🎭 La plus courte liaison ✓ Prix fixe dès 35€ ✓ Hôtels Puy du Fou.',
      keywords: 'vtc les herbiers puy du fou, transfert les herbiers puy du fou, navette les herbiers puy du fou',
      heroImage: 'https://images.unsplash.com/photo-1671572990341-31584046103d?w=1920&q=80&fm=webp',
      distance: '12 km', duration: '15 min', price: 'dès 35€', priceReturn: 'dès 65€',
      fromCoords: { lat: 46.8694, lng: -1.0122 }, toCoords: { lat: 46.8897, lng: -0.9306 },
      highlights: [
        'Liaison la plus courte vers le Puy du Fou',
        'Prise en charge Mont des Alouettes',
        'Desserte hôtels Les Herbiers',
        'Retour Cinéscénie (minuit)',
        'Tarif ultra-compétitif'
      ],
      description: `VTC Les Herbiers vers le Puy du Fou. Le trajet le plus court (12 km, 15 min) pour rejoindre le meilleur parc du monde. Idéal pour les visiteurs séjournant dans les hôtels et gîtes du Bocage Vendéen.`,
      faq: [
        { question: 'Prix VTC Les Herbiers → Puy du Fou ?', answer: 'Tarif fixe dès 35€ (12 km, 15 min). Aller-retour 65€. Service Cinéscénie avec retour tardif.' }
      ]
    }
  ],

  // ===============================================
  // TRAJETS VERS GARE HALUCHÈRE-BATIGNOLLES
  // ===============================================
  haluchere: [
    {
      slug: 'vtc-saint-nazaire-haluchere',
      from: 'Saint-Nazaire',
      to: 'Gare Haluchère-Batignolles',
      title: 'VTC Saint-Nazaire Gare Haluchère - Chauffeur Privé | Réservation Goloire-Cab au 02 59 22 20 00',
      metaDescription: 'VTC Saint-Nazaire ↔ Gare Haluchère-Batignolles ⚡ Connexion TGV 🚗 Prix fixe 120€ ✓ Correspondances train ✓ Réservez !',
      keywords: 'vtc saint nazaire haluchere, navette saint nazaire gare haluchere, transport saint nazaire haluchere',
      heroImage: 'https://images.unsplash.com/photo-1515165562839-978bbcf18277?w=1920&q=80&fm=webp',
      distance: '60 km',
      duration: '45 min',
      price: 'dès 120€',
      priceReturn: 'dès 215€',
      fromCoords: { lat: 47.2730, lng: -2.2137 },
      toCoords: { lat: 47.2456, lng: -1.5239 },
      highlights: [
        'Connexion TGV',
        'Correspondances facilitées',
        'Service ponctuel',
        'Suivi horaires trains',
        'Aide aux bagages'
      ],
      description: `Service VTC Saint-Nazaire vers la Gare Haluchère-Batignolles. Connexion optimale avec les lignes TGV et TER. Nos chauffeurs suivent les horaires de train pour assurer vos correspondances.`,
      faq: [
        {
          question: 'Pourquoi choisir la gare Haluchère ?',
          answer: 'La gare Haluchère-Batignolles offre un accès direct aux TGV vers Paris, Lyon, et les lignes TER régionales, avec un stationnement plus facile qu\'à Nantes centre.'
        },
        {
          question: 'Que se passe-t-il si mon train est en retard ?',
          answer: 'Nous suivons les horaires SNCF en temps réel et nous adaptons sans frais supplémentaires.'
        }
      ]
    },
    {
      slug: 'vtc-la-baule-haluchere',
      from: 'La Baule',
      to: 'Gare Haluchère-Batignolles',
      title: 'VTC La Baule Gare Haluchère - Chauffeur Privé | Réservation Goloire-Cab au 02 59 22 20 00',
      metaDescription: 'VTC La Baule ↔ Gare Haluchère ⚡ Connexion TGV premium 🚗 Prix fixe 185€ ✓ Tesla ✓ Réservez !',
      keywords: 'vtc la baule haluchere, navette la baule gare haluchere',
      heroImage: 'https://images.unsplash.com/photo-1515165562839-978bbcf18277?w=1920&q=80&fm=webp',
      distance: '75 km',
      duration: '1h00',
      price: 'dès 185€',
      priceReturn: 'dès 345€',
      fromCoords: { lat: 47.2861, lng: -2.3933 },
      toCoords: { lat: 47.2456, lng: -1.5239 },
      highlights: [
        'Service premium La Baule',
        'Connexion TGV Paris',
        'Prise en charge hôtels',
        'Bagages volumineux'
      ],
      description: `VTC premium La Baule vers Gare Haluchère-Batignolles. Service haut de gamme pour vos connexions TGV.`,
      faq: []
    },
    {
      slug: 'vtc-pornic-haluchere',
      from: 'Pornic',
      to: 'Gare Haluchère-Batignolles',
      title: 'VTC Pornic Gare Haluchère - Chauffeur Privé | Réservation Goloire-Cab au 02 59 22 20 00',
      metaDescription: 'VTC Pornic ↔ Gare Haluchère ⚡ Connexion train 🚗 Prix fixe 195€ ✓ Réservez !',
      keywords: 'vtc pornic haluchere, navette pornic gare haluchere',
      heroImage: 'https://images.unsplash.com/photo-1515165562839-978bbcf18277?w=1920&q=80&fm=webp',
      distance: '50 km',
      duration: '45 min',
      price: 'dès 195€',
      priceReturn: 'dès 205€',
      fromCoords: { lat: 47.1167, lng: -2.1000 },
      toCoords: { lat: 47.2456, lng: -1.5239 },
      highlights: [
        'Côte de Jade - TGV',
        'Correspondances facilitées',
        'Service ponctuel'
      ],
      description: `VTC Pornic vers Gare Haluchère-Batignolles. Connexion train depuis la Côte de Jade.`,
      faq: []
    },
    {
      slug: 'vtc-guerande-haluchere',
      from: 'Guérande',
      to: 'Gare Haluchère-Batignolles',
      title: 'VTC Guérande Gare Haluchère - Chauffeur Privé | Réservation Goloire-Cab au 02 59 22 20 00',
      metaDescription: 'VTC Guérande ↔ Gare Haluchère ⚡ Connexion TGV 🚗 Prix fixe 175€ ✓ Réservez !',
      keywords: 'vtc guerande haluchere, navette guerande gare haluchere',
      heroImage: 'https://images.unsplash.com/photo-1515165562839-978bbcf18277?w=1920&q=80&fm=webp',
      distance: '70 km',
      duration: '55 min',
      price: 'dès 175€',
      priceReturn: 'dès 325€',
      fromCoords: { lat: 47.3278, lng: -2.4297 },
      toCoords: { lat: 47.2456, lng: -1.5239 },
      highlights: [
        'Cité médiévale - TGV',
        'Service premium',
        'Suivi horaires'
      ],
      description: `VTC Guérande vers Gare Haluchère-Batignolles. Liaison pour vos connexions TGV.`,
      faq: []
    },
    {
      slug: 'vtc-clisson-haluchere',
      from: 'Clisson',
      to: 'Gare Haluchère-Batignolles',
      title: 'VTC Clisson Gare Haluchère - Chauffeur Privé | Réservation Goloire-Cab au 02 59 22 20 00',
      metaDescription: 'VTC Clisson ↔ Gare Haluchère ⚡ Connexion TGV 🚗 Prix fixe 85€ ✓ Réservez !',
      keywords: 'vtc clisson haluchere, navette clisson gare haluchere',
      heroImage: 'https://images.unsplash.com/photo-1515165562839-978bbcf18277?w=1920&q=80&fm=webp',
      distance: '32 km',
      duration: '30 min',
      price: 'dès 85€',
      priceReturn: 'dès 160€',
      fromCoords: { lat: 47.0872, lng: -1.2828 },
      toCoords: { lat: 47.2456, lng: -1.5239 },
      highlights: [
        'Vignoble - TGV',
        'Trajet rapide',
        'Correspondances train'
      ],
      description: `VTC Clisson vers Gare Haluchère-Batignolles. Connexion rapide depuis le vignoble.`,
      faq: []
    },
    {
      slug: 'vtc-ancenis-haluchere',
      from: 'Ancenis',
      to: 'Gare Haluchère-Batignolles',
      title: 'VTC Ancenis Gare Haluchère - Chauffeur Privé | Réservation Goloire-Cab au 02 59 22 20 00',
      metaDescription: 'VTC Ancenis ↔ Gare Haluchère ⚡ Connexion TGV 🚗 Prix fixe 195€ ✓ Réservez !',
      keywords: 'vtc ancenis haluchere, navette ancenis gare haluchere',
      heroImage: 'https://images.unsplash.com/photo-1515165562839-978bbcf18277?w=1920&q=80&fm=webp',
      distance: '45 km',
      duration: '40 min',
      price: 'dès 195€',
      priceReturn: 'dès 205€',
      fromCoords: { lat: 47.3667, lng: -1.1833 },
      toCoords: { lat: 47.2456, lng: -1.5239 },
      highlights: [
        'Est département - TGV',
        'Service professionnel',
        'Suivi horaires'
      ],
      description: `VTC Ancenis vers Gare Haluchère-Batignolles. Connexion TGV depuis l'est du département.`,
      faq: []
    },
    {
      slug: 'vtc-carquefou-haluchere',
      from: 'Carquefou',
      to: 'Gare Haluchère-Batignolles',
      title: 'VTC Carquefou Gare Haluchère - Chauffeur Privé | Réservation Goloire-Cab au 02 59 22 20 00',
      metaDescription: 'VTC Carquefou ↔ Gare Haluchère ⚡ Service express 🚗 Prix fixe 45€ ✓ Réservez !',
      keywords: 'vtc carquefou haluchere, navette carquefou gare haluchere',
      heroImage: 'https://images.unsplash.com/photo-1515165562839-978bbcf18277?w=1920&q=80&fm=webp',
      distance: '8 km',
      duration: '12 min',
      price: 'dès 45€',
      priceReturn: 'dès 75€',
      fromCoords: { lat: 47.2978, lng: -1.4933 },
      toCoords: { lat: 47.2456, lng: -1.5239 },
      highlights: [
        'Proximité gare',
        'Service express',
        'Zones d\'activité'
      ],
      description: `VTC Carquefou vers Gare Haluchère-Batignolles. Service express depuis les zones d'activité.`,
      faq: []
    },
    {
      slug: 'vtc-orvault-haluchere',
      from: 'Orvault',
      to: 'Gare Haluchère-Batignolles',
      title: 'VTC Orvault Gare Haluchère - Chauffeur Privé | Réservation Goloire-Cab au 02 59 22 20 00',
      metaDescription: 'VTC Orvault ↔ Gare Haluchère ⚡ Service rapide 🚗 Prix fixe 30€ ✓ Réservez !',
      keywords: 'vtc orvault haluchere, navette orvault gare haluchere',
      heroImage: 'https://images.unsplash.com/photo-1515165562839-978bbcf18277?w=1920&q=80&fm=webp',
      distance: '5 km',
      duration: '10 min',
      price: 'dès 30€',
      priceReturn: 'dès 60€',
      fromCoords: { lat: 47.2711, lng: -1.6217 },
      toCoords: { lat: 47.2456, lng: -1.5239 },
      highlights: [
        'Nord métropole',
        'Trajet court',
        'Tarif économique'
      ],
      description: `VTC Orvault vers Gare Haluchère-Batignolles. Service rapide et économique.`,
      faq: []
    },
    {
      slug: 'vtc-vertou-haluchere',
      from: 'Vertou',
      to: 'Gare Haluchère-Batignolles',
      title: 'VTC Vertou Gare Haluchère - Chauffeur Privé | Réservation Goloire-Cab au 02 59 22 20 00',
      metaDescription: 'VTC Vertou ↔ Gare Haluchère ⚡ Connexion TGV 🚗 Prix fixe 95€ ✓ Réservez !',
      keywords: 'vtc vertou haluchere, navette vertou gare haluchere',
      heroImage: 'https://images.unsplash.com/photo-1515165562839-978bbcf18277?w=1920&q=80&fm=webp',
      distance: '12 km',
      duration: '20 min',
      price: 'dès 95€',
      priceReturn: 'dès 95€',
      fromCoords: { lat: 47.1681, lng: -1.4692 },
      toCoords: { lat: 47.2456, lng: -1.5239 },
      highlights: [
        'Sud métropole',
        'Vignoble',
        'Service ponctuel'
      ],
      description: `VTC Vertou vers Gare Haluchère-Batignolles. Connexion train depuis le sud de la métropole.`,
      faq: []
    },
    {
      slug: 'vtc-reze-haluchere',
      from: 'Rezé',
      to: 'Gare Haluchère-Batignolles',
      title: 'VTC Rezé Gare Haluchère - Chauffeur Privé | Réservation Goloire-Cab au 02 59 22 20 00',
      metaDescription: 'VTC Rezé ↔ Gare Haluchère ⚡ Service rapide 🚗 Prix fixe 45€ ✓ Réservez !',
      keywords: 'vtc reze haluchere, navette reze gare haluchere',
      heroImage: 'https://images.unsplash.com/photo-1515165562839-978bbcf18277?w=1920&q=80&fm=webp',
      distance: '10 km',
      duration: '18 min',
      price: 'dès 45€',
      priceReturn: 'dès 75€',
      fromCoords: { lat: 47.1833, lng: -1.5500 },
      toCoords: { lat: 47.2456, lng: -1.5239 },
      highlights: [
        'Sud Nantes',
        'Trentemoult',
        'Connexion TGV'
      ],
      description: `VTC Rezé vers Gare Haluchère-Batignolles. Liaison rapide pour vos correspondances.`,
      faq: []
    },
    {
      slug: 'vtc-challans-haluchere',
      from: 'Challans',
      to: 'Gare Haluchère-Batignolles',
      title: 'VTC Challans Gare Haluchère - Chauffeur Privé | Réservation Goloire-Cab au 02 59 22 20 00',
      metaDescription: 'VTC Challans ↔ Gare Haluchère ⚡ Connexion TGV Vendée 🚗 Prix fixe 150€ ✓ Réservez !',
      keywords: 'vtc challans haluchere, navette challans gare haluchere',
      heroImage: 'https://images.unsplash.com/photo-1515165562839-978bbcf18277?w=1920&q=80&fm=webp',
      distance: '65 km',
      duration: '55 min',
      price: 'dès 150€',
      priceReturn: 'dès 280€',
      fromCoords: { lat: 46.8467, lng: -1.8783 },
      toCoords: { lat: 47.2456, lng: -1.5239 },
      highlights: [
        'Vendée - TGV Paris',
        'Inter-département',
        'Service premium'
      ],
      description: `VTC Challans vers Gare Haluchère-Batignolles. Connexion TGV depuis le nord Vendée.`,
      faq: []
    },
    {
      slug: 'vtc-noirmoutier-haluchere',
      from: 'Noirmoutier',
      to: 'Gare Haluchère-Batignolles',
      title: 'VTC Noirmoutier Gare Haluchère - Chauffeur Privé | Réservation Goloire-Cab au 02 59 22 20 00',
      metaDescription: 'VTC Noirmoutier ↔ Gare Haluchère ⚡ Service insulaire TGV 🚗 Prix fixe 110€ ✓ Réservez !',
      keywords: 'vtc noirmoutier haluchere, navette noirmoutier gare haluchere',
      heroImage: 'https://images.unsplash.com/photo-1515165562839-978bbcf18277?w=1920&q=80&fm=webp',
      distance: '85 km',
      duration: '1h15',
      price: 'Sur devis',
      priceReturn: 'Sur devis',
      fromCoords: { lat: 46.9983, lng: -2.2450 },
      toCoords: { lat: 47.2456, lng: -1.5239 },
      highlights: [
        'Île - TGV Paris',
        'Service insulaire',
        'Bagages volumineux'
      ],
      description: `VTC Noirmoutier vers Gare Haluchère-Batignolles. Connexion TGV depuis l'île.`,
      faq: []
    }
  ],
  
  // ===============================================
  // TRAJETS VALLÉE DE LA LOIRE EST - JANVIER 2026
  // ===============================================
  loireEst: [
    // SAINTE-LUCE-SUR-LOIRE
    {
      slug: 'vtc-sainte-luce-sur-loire-aeroport',
      from: 'Sainte-Luce-sur-Loire',
      to: 'Aéroport Nantes Atlantique',
      title: 'VTC Sainte-Luce-sur-Loire Aéroport - Chauffeur Privé | Réservation Goloire-Cab au 02 59 22 20 00',
      metaDescription: 'Transfert VTC Sainte-Luce-sur-Loire ↔ Aéroport Nantes Atlantique ⚡ Chauffeur privé 24h/24 🚗 Suivi des vols ✓ Tesla premium ✓ Devis gratuit immédiat !',
      keywords: 'vtc sainte luce sur loire aeroport, transfert sainte luce aeroport nantes, navette sainte luce aeroport, taxi sainte luce aeroport nantes',
      heroImage: 'https://images.unsplash.com/photo-1436491865332-7a61a109cc05?w=1920&q=80&fm=webp',
      distance: '12 km',
      duration: '18 min',
      price: 'Sur devis',
      priceReturn: 'Sur devis',
      fromCoords: { lat: 47.2519, lng: -1.4903 },
      toCoords: { lat: 47.1531, lng: -1.6108 },
      highlights: [
        'Prise en charge à domicile',
        'Suivi des vols en temps réel',
        'Trajet rapide via périphérique',
        'Aide aux bagages incluse',
        'Service 24h/24, 7j/7',
        'Véhicules électriques Tesla'
      ],
      description: `Service de transfert VTC premium entre Sainte-Luce-sur-Loire et l'Aéroport Nantes Atlantique. Profitez d'un trajet rapide et confortable grâce à l'accès direct au périphérique nantais. Nos chauffeurs professionnels suivent votre vol et s'adaptent aux horaires. Idéal pour vos départs matinaux ou arrivées tardives.`,
      faq: [
        {
          question: 'Combien de temps dure le trajet Sainte-Luce Aéroport ?',
          answer: 'Le trajet dure environ 18 minutes en conditions normales via le périphérique Est et Sud de Nantes.'
        },
        {
          question: 'Proposez-vous un service pour les vols tôt le matin ?',
          answer: 'Oui, notre service est disponible 24h/24. Nous assurons les transferts pour tous les vols, même très matinaux.'
        }
      ],
      category: 'loireEst'
    },
    {
      slug: 'vtc-sainte-luce-sur-loire-nantes',
      from: 'Sainte-Luce-sur-Loire',
      to: 'Nantes Centre',
      title: 'VTC Sainte-Luce-sur-Loire Nantes - Chauffeur Privé | Réservation Goloire-Cab au 02 59 22 20 00',
      metaDescription: 'Transfert VTC Sainte-Luce-sur-Loire ↔ Nantes Centre ⚡ Service rapide 24h/24 🚗 Chauffeur privé Tesla ✓ Gare SNCF ✓ Demandez votre devis gratuit !',
      keywords: 'vtc sainte luce sur loire nantes, transfert sainte luce nantes centre, taxi sainte luce nantes, chauffeur privé sainte luce',
      heroImage: 'https://images.unsplash.com/photo-1449965408869-eaa3f722e40d?w=1920&q=80&fm=webp',
      distance: '8 km',
      duration: '15 min',
      price: 'Sur devis',
      priceReturn: 'Sur devis',
      fromCoords: { lat: 47.2519, lng: -1.4903 },
      toCoords: { lat: 47.2184, lng: -1.5536 },
      highlights: [
        'Liaison directe centre-ville',
        'Desserte gare SNCF Nantes',
        'Trajet express 15 minutes',
        'Idéal rendez-vous professionnels',
        'Service soirées et week-ends',
        'Véhicules confortables'
      ],
      description: `VTC Sainte-Luce-sur-Loire vers Nantes Centre. Rejoignez rapidement le centre-ville, la gare SNCF ou vos rendez-vous professionnels. Service disponible 24h/24 pour tous vos déplacements.`,
      faq: [
        {
          question: 'Desservez-vous la gare SNCF de Nantes ?',
          answer: 'Oui, nous assurons les transferts vers la gare SNCF de Nantes pour vos correspondances TGV et TER.'
        }
      ],
      category: 'loireEst'
    },
    
    // THOUARÉ-SUR-LOIRE
    {
      slug: 'vtc-thouare-sur-loire-aeroport',
      from: 'Thouaré-sur-Loire',
      to: 'Aéroport Nantes Atlantique',
      title: 'VTC Thouaré-sur-Loire Aéroport - Chauffeur Privé | Réservation Goloire-Cab au 02 59 22 20 00',
      metaDescription: 'Transfert VTC Thouaré-sur-Loire ↔ Aéroport Nantes Atlantique ⚡ Chauffeur privé 24h/24 🚗 Suivi des vols ✓ Devis gratuit en ligne !',
      keywords: 'vtc thouare sur loire aeroport, transfert thouare aeroport nantes, navette thouare aeroport, taxi thouare aeroport',
      heroImage: 'https://images.unsplash.com/photo-1436491865332-7a61a109cc05?w=1920&q=80&fm=webp',
      distance: '15 km',
      duration: '22 min',
      price: 'Sur devis',
      priceReturn: 'Sur devis',
      fromCoords: { lat: 47.2681, lng: -1.4397 },
      toCoords: { lat: 47.1531, lng: -1.6108 },
      highlights: [
        'Prise en charge à domicile',
        'Suivi des vols en temps réel',
        'Accès rapide via N844',
        'Aide aux bagages incluse',
        'Service 24h/24, 7j/7',
        'Tarif fixe garanti'
      ],
      description: `Service de transfert VTC entre Thouaré-sur-Loire et l'Aéroport Nantes Atlantique. Profitez d'un trajet confortable et ponctuel avec nos chauffeurs professionnels.`,
      faq: [],
      category: 'loireEst'
    },
    {
      slug: 'vtc-thouare-sur-loire-nantes',
      from: 'Thouaré-sur-Loire',
      to: 'Nantes Centre',
      title: 'VTC Thouaré-sur-Loire Nantes - Chauffeur Privé | Réservation Goloire-Cab au 02 59 22 20 00',
      metaDescription: 'Transfert VTC Thouaré-sur-Loire ↔ Nantes Centre ⚡ Service rapide 🚗 Chauffeur privé ✓ Gare SNCF ✓ Demandez votre devis gratuit !',
      keywords: 'vtc thouare sur loire nantes, transfert thouare nantes centre, taxi thouare nantes, chauffeur privé thouare',
      heroImage: 'https://images.unsplash.com/photo-1449965408869-eaa3f722e40d?w=1920&q=80&fm=webp',
      distance: '10 km',
      duration: '18 min',
      price: 'Sur devis',
      priceReturn: 'Sur devis',
      fromCoords: { lat: 47.2681, lng: -1.4397 },
      toCoords: { lat: 47.2184, lng: -1.5536 },
      highlights: [
        'Liaison rapide centre-ville',
        'Desserte gare SNCF',
        'Trajet 18 minutes',
        'Service soirées et week-ends'
      ],
      description: `VTC Thouaré-sur-Loire vers Nantes Centre. Rejoignez rapidement le centre-ville ou la gare SNCF avec notre service de chauffeur privé.`,
      faq: [],
      category: 'loireEst'
    },
    
    // MAUVES-SUR-LOIRE
    {
      slug: 'vtc-mauves-sur-loire-aeroport',
      from: 'Mauves-sur-Loire',
      to: 'Aéroport Nantes Atlantique',
      title: 'VTC Mauves-sur-Loire Aéroport - Chauffeur Privé | Réservation Goloire-Cab au 02 59 22 20 00',
      metaDescription: 'Transfert VTC Mauves-sur-Loire ↔ Aéroport Nantes Atlantique ⚡ Village viticole 🍷 Chauffeur privé 24h/24 ✓ Suivi des vols ✓ Devis gratuit !',
      keywords: 'vtc mauves sur loire aeroport, transfert mauves aeroport nantes, navette mauves aeroport, taxi mauves aeroport, muscadet',
      heroImage: 'https://images.unsplash.com/photo-1436491865332-7a61a109cc05?w=1920&q=80&fm=webp',
      distance: '22 km',
      duration: '28 min',
      price: 'Sur devis',
      priceReturn: 'Sur devis',
      fromCoords: { lat: 47.3044, lng: -1.3903 },
      toCoords: { lat: 47.1531, lng: -1.6108 },
      highlights: [
        'Village viticole du Muscadet',
        'Prise en charge domicile',
        'Suivi des vols',
        'Service œnotourisme',
        'Bagages et caisses de vin',
        'Chauffeur professionnel'
      ],
      description: `Transfert VTC depuis Mauves-sur-Loire, village viticole des bords de Loire, vers l'Aéroport Nantes Atlantique. Service idéal pour les amateurs de vin visitant le vignoble du Muscadet.`,
      faq: [
        {
          question: 'Pouvez-vous transporter des caisses de vin ?',
          answer: 'Oui, nos véhicules peuvent accueillir vos achats de vin. Prévoyez-nous lors de la réservation.'
        }
      ],
      category: 'loireEst'
    },
    {
      slug: 'vtc-mauves-sur-loire-nantes',
      from: 'Mauves-sur-Loire',
      to: 'Nantes Centre',
      title: 'VTC Mauves-sur-Loire Nantes - Chauffeur Privé | Réservation Goloire-Cab au 02 59 22 20 00',
      metaDescription: 'Transfert VTC Mauves-sur-Loire ↔ Nantes Centre ⚡ Village viticole Muscadet 🍷 Chauffeur privé ✓ Devis gratuit immédiat !',
      keywords: 'vtc mauves sur loire nantes, transfert mauves nantes, taxi mauves nantes, chauffeur privé mauves muscadet',
      heroImage: 'https://images.unsplash.com/photo-1449965408869-eaa3f722e40d?w=1920&q=80&fm=webp',
      distance: '15 km',
      duration: '22 min',
      price: 'Sur devis',
      priceReturn: 'Sur devis',
      fromCoords: { lat: 47.3044, lng: -1.3903 },
      toCoords: { lat: 47.2184, lng: -1.5536 },
      highlights: [
        'Liaison vignoble - ville',
        'Desserte gare SNCF',
        'Service œnotourisme',
        'Soirées et week-ends'
      ],
      description: `VTC Mauves-sur-Loire vers Nantes Centre. Liaison directe depuis ce village viticole réputé vers le centre-ville et la gare SNCF de Nantes.`,
      faq: [],
      category: 'loireEst'
    },
    
    // OUDON
    {
      slug: 'vtc-oudon-aeroport',
      from: 'Oudon',
      to: 'Aéroport Nantes Atlantique',
      title: 'VTC Oudon Aéroport - Chauffeur Privé | Réservation Goloire-Cab au 02 59 22 20 00',
      metaDescription: 'Transfert VTC Oudon ↔ Aéroport Nantes Atlantique ⚡ Tour médiévale 🏰 Chauffeur privé 24h/24 ✓ Suivi des vols ✓ Devis gratuit !',
      keywords: 'vtc oudon aeroport, transfert oudon aeroport nantes, navette oudon aeroport, taxi oudon aeroport, tour oudon',
      heroImage: 'https://images.unsplash.com/photo-1436491865332-7a61a109cc05?w=1920&q=80&fm=webp',
      distance: '32 km',
      duration: '35 min',
      price: 'Sur devis',
      priceReturn: 'Sur devis',
      fromCoords: { lat: 47.3489, lng: -1.2847 },
      toCoords: { lat: 47.1531, lng: -1.6108 },
      highlights: [
        'Cité médiévale - Tour XIVe',
        'Prise en charge domicile',
        'Suivi des vols en direct',
        'Accès via N23',
        'Service 24h/24',
        'Véhicules spacieux'
      ],
      description: `Transfert VTC depuis Oudon, cité médiévale dominée par sa célèbre tour du XIVe siècle, vers l'Aéroport Nantes Atlantique. Service premium pour vos voyages.`,
      faq: [],
      category: 'loireEst'
    },
    {
      slug: 'vtc-oudon-nantes',
      from: 'Oudon',
      to: 'Nantes Centre',
      title: 'VTC Oudon Nantes - Chauffeur Privé | Réservation Goloire-Cab au 02 59 22 20 00',
      metaDescription: 'Transfert VTC Oudon ↔ Nantes Centre ⚡ Cité médiévale 🏰 Chauffeur privé ✓ Gare SNCF ✓ Devis gratuit immédiat !',
      keywords: 'vtc oudon nantes, transfert oudon nantes centre, taxi oudon nantes, chauffeur privé oudon',
      heroImage: 'https://images.unsplash.com/photo-1449965408869-eaa3f722e40d?w=1920&q=80&fm=webp',
      distance: '25 km',
      duration: '28 min',
      price: 'Sur devis',
      priceReturn: 'Sur devis',
      fromCoords: { lat: 47.3489, lng: -1.2847 },
      toCoords: { lat: 47.2184, lng: -1.5536 },
      highlights: [
        'Liaison Loire - Nantes',
        'Desserte gare SNCF',
        'Vue sur la Loire',
        'Service tous les jours'
      ],
      description: `VTC Oudon vers Nantes Centre. Rejoignez facilement le centre-ville et la gare SNCF depuis cette charmante cité médiévale.`,
      faq: [],
      category: 'loireEst'
    },
    
    // LE CELLIER
    {
      slug: 'vtc-le-cellier-aeroport',
      from: 'Le Cellier',
      to: 'Aéroport Nantes Atlantique',
      title: 'VTC Le Cellier Aéroport - Chauffeur Privé | Réservation Goloire-Cab au 02 59 22 20 00',
      metaDescription: 'Transfert VTC Le Cellier ↔ Aéroport Nantes Atlantique ⚡ Château de Clermont 🏛️ Chauffeur privé 24h/24 ✓ Suivi des vols ✓ Devis gratuit !',
      keywords: 'vtc le cellier aeroport, transfert le cellier aeroport nantes, navette cellier aeroport, taxi cellier aeroport, chateau clermont',
      heroImage: 'https://images.unsplash.com/photo-1436491865332-7a61a109cc05?w=1920&q=80&fm=webp',
      distance: '28 km',
      duration: '32 min',
      price: 'Sur devis',
      priceReturn: 'Sur devis',
      fromCoords: { lat: 47.3219, lng: -1.3522 },
      toCoords: { lat: 47.1531, lng: -1.6108 },
      highlights: [
        'Village du Château de Clermont',
        'Panorama sur la Loire',
        'Vignoble du Muscadet',
        'Suivi des vols',
        'Service 24h/24',
        'Prise en charge à domicile'
      ],
      description: `Transfert VTC depuis Le Cellier, village réputé pour son Château de Clermont et ses panoramas sur la Loire, vers l'Aéroport Nantes Atlantique.`,
      faq: [],
      category: 'loireEst'
    },
    {
      slug: 'vtc-le-cellier-nantes',
      from: 'Le Cellier',
      to: 'Nantes Centre',
      title: 'VTC Le Cellier Nantes - Chauffeur Privé | Réservation Goloire-Cab au 02 59 22 20 00',
      metaDescription: 'Transfert VTC Le Cellier ↔ Nantes Centre ⚡ Château de Clermont 🏛️ Chauffeur privé ✓ Gare SNCF ✓ Devis gratuit !',
      keywords: 'vtc le cellier nantes, transfert cellier nantes centre, taxi cellier nantes, chauffeur privé le cellier',
      heroImage: 'https://images.unsplash.com/photo-1449965408869-eaa3f722e40d?w=1920&q=80&fm=webp',
      distance: '20 km',
      duration: '25 min',
      price: 'Sur devis',
      priceReturn: 'Sur devis',
      fromCoords: { lat: 47.3219, lng: -1.3522 },
      toCoords: { lat: 47.2184, lng: -1.5536 },
      highlights: [
        'Village viticole - Nantes',
        'Desserte gare SNCF',
        'Vignoble Muscadet',
        'Service tous les jours'
      ],
      description: `VTC Le Cellier vers Nantes Centre. Liaison confortable depuis ce village viticole vers le centre-ville et la gare SNCF de Nantes.`,
      faq: [],
      category: 'loireEst'
    },
    
    // DIVATTE-SUR-LOIRE
    {
      slug: 'vtc-divatte-sur-loire-aeroport',
      from: 'Divatte-sur-Loire',
      to: 'Aéroport Nantes Atlantique',
      title: 'VTC Divatte-sur-Loire Aéroport - Chauffeur Privé | Réservation Goloire-Cab au 02 59 22 20 00',
      metaDescription: 'Transfert VTC Divatte-sur-Loire ↔ Aéroport Nantes Atlantique ⚡ Muscadet Sèvre-et-Maine 🍷 Chauffeur privé 24h/24 ✓ Devis gratuit !',
      keywords: 'vtc divatte sur loire aeroport, transfert divatte aeroport nantes, navette divatte aeroport, taxi divatte aeroport, la chapelle basse mer',
      heroImage: 'https://images.unsplash.com/photo-1436491865332-7a61a109cc05?w=1920&q=80&fm=webp',
      distance: '25 km',
      duration: '30 min',
      price: 'Sur devis',
      priceReturn: 'Sur devis',
      fromCoords: { lat: 47.2767, lng: -1.3181 },
      toCoords: { lat: 47.1531, lng: -1.6108 },
      highlights: [
        'Terroir Muscadet Sèvre-et-Maine',
        'La Chapelle-Basse-Mer, Barbechat',
        'Suivi des vols',
        'Prise en charge domicile',
        'Bagages et caisses de vin',
        'Service 24h/24'
      ],
      description: `Transfert VTC depuis Divatte-sur-Loire, commune nouvelle au cœur du vignoble du Muscadet, vers l'Aéroport Nantes Atlantique.`,
      faq: [],
      category: 'loireEst'
    },
    {
      slug: 'vtc-divatte-sur-loire-nantes',
      from: 'Divatte-sur-Loire',
      to: 'Nantes Centre',
      title: 'VTC Divatte-sur-Loire Nantes - Chauffeur Privé | Réservation Goloire-Cab au 02 59 22 20 00',
      metaDescription: 'Transfert VTC Divatte-sur-Loire ↔ Nantes Centre ⚡ Muscadet Sèvre-et-Maine 🍷 Chauffeur privé ✓ Devis gratuit !',
      keywords: 'vtc divatte sur loire nantes, transfert divatte nantes, taxi divatte nantes, chauffeur privé divatte',
      heroImage: 'https://images.unsplash.com/photo-1449965408869-eaa3f722e40d?w=1920&q=80&fm=webp',
      distance: '22 km',
      duration: '28 min',
      price: 'Sur devis',
      priceReturn: 'Sur devis',
      fromCoords: { lat: 47.2767, lng: -1.3181 },
      toCoords: { lat: 47.2184, lng: -1.5536 },
      highlights: [
        'Vignoble - centre-ville',
        'Desserte gare SNCF',
        'Marais de Goulaine',
        'Service tous les jours'
      ],
      description: `VTC Divatte-sur-Loire vers Nantes Centre. Liaison depuis ce terroir viticole vers le centre-ville et la gare SNCF.`,
      faq: [],
      category: 'loireEst'
    },
    
    // LE LOROUX-BOTTEREAU
    {
      slug: 'vtc-le-loroux-bottereau-aeroport',
      from: 'Le Loroux-Bottereau',
      to: 'Aéroport Nantes Atlantique',
      title: 'VTC Le Loroux-Bottereau Aéroport - Chauffeur Privé | Réservation Goloire-Cab au 02 59 22 20 00',
      metaDescription: 'Transfert VTC Le Loroux-Bottereau ↔ Aéroport Nantes Atlantique ⚡ Capitale du Muscadet 🍷 Chauffeur privé 24h/24 ✓ Devis gratuit !',
      keywords: 'vtc le loroux bottereau aeroport, transfert loroux bottereau aeroport, navette loroux aeroport, taxi loroux aeroport, muscadet sevre maine',
      heroImage: 'https://images.unsplash.com/photo-1436491865332-7a61a109cc05?w=1920&q=80&fm=webp',
      distance: '22 km',
      duration: '28 min',
      price: 'Sur devis',
      priceReturn: 'Sur devis',
      fromCoords: { lat: 47.2397, lng: -1.3494 },
      toCoords: { lat: 47.1531, lng: -1.6108 },
      highlights: [
        'Capitale du Muscadet',
        'Foire aux vins réputée',
        'Nombreuses caves',
        'Suivi des vols',
        'Transport caisses de vin',
        'Service 24h/24'
      ],
      description: `Transfert VTC depuis Le Loroux-Bottereau, capitale du Muscadet Sèvre-et-Maine, vers l'Aéroport Nantes Atlantique. Service idéal pour les amateurs de vin.`,
      faq: [
        {
          question: 'Proposez-vous des circuits œnotourisme ?',
          answer: 'Oui, nous proposons des circuits de découverte des caves et domaines viticoles du Muscadet. Contactez-nous pour un devis personnalisé.'
        }
      ],
      category: 'loireEst'
    },
    {
      slug: 'vtc-le-loroux-bottereau-nantes',
      from: 'Le Loroux-Bottereau',
      to: 'Nantes Centre',
      title: 'VTC Le Loroux-Bottereau Nantes - Chauffeur Privé | Réservation Goloire-Cab au 02 59 22 20 00',
      metaDescription: 'Transfert VTC Le Loroux-Bottereau ↔ Nantes Centre ⚡ Capitale du Muscadet 🍷 Chauffeur privé ✓ Devis gratuit !',
      keywords: 'vtc le loroux bottereau nantes, transfert loroux nantes, taxi loroux nantes, chauffeur privé loroux bottereau',
      heroImage: 'https://images.unsplash.com/photo-1449965408869-eaa3f722e40d?w=1920&q=80&fm=webp',
      distance: '18 km',
      duration: '25 min',
      price: 'Sur devis',
      priceReturn: 'Sur devis',
      fromCoords: { lat: 47.2397, lng: -1.3494 },
      toCoords: { lat: 47.2184, lng: -1.5536 },
      highlights: [
        'Capitale Muscadet - Nantes',
        'Desserte gare SNCF',
        'Œnotourisme',
        'Service tous les jours'
      ],
      description: `VTC Le Loroux-Bottereau vers Nantes Centre. Liaison depuis la capitale du Muscadet vers le centre-ville et la gare SNCF.`,
      faq: [],
      category: 'loireEst'
    },
    
    // LA VARENNE
    {
      slug: 'vtc-la-varenne-aeroport',
      from: 'La Varenne',
      to: 'Aéroport Nantes Atlantique',
      title: 'VTC La Varenne Aéroport - Chauffeur Privé | Réservation Goloire-Cab au 02 59 22 20 00',
      metaDescription: 'Transfert VTC La Varenne ↔ Aéroport Nantes Atlantique ⚡ Coteaux du Muscadet 🍷 Chauffeur privé 24h/24 ✓ Devis gratuit !',
      keywords: 'vtc la varenne aeroport, transfert la varenne aeroport nantes, navette varenne aeroport, taxi varenne aeroport',
      heroImage: 'https://images.unsplash.com/photo-1436491865332-7a61a109cc05?w=1920&q=80&fm=webp',
      distance: '32 km',
      duration: '38 min',
      price: 'Sur devis',
      priceReturn: 'Sur devis',
      fromCoords: { lat: 47.2978, lng: -1.2611 },
      toCoords: { lat: 47.1531, lng: -1.6108 },
      highlights: [
        'Coteaux du Muscadet',
        'Vue vallée de la Loire',
        'Suivi des vols',
        'Prise en charge domicile',
        'Service 24h/24',
        'Liaison Ancenis'
      ],
      description: `Transfert VTC depuis La Varenne, village viticole des coteaux du Muscadet, vers l'Aéroport Nantes Atlantique.`,
      faq: [],
      category: 'loireEst'
    },
    {
      slug: 'vtc-la-varenne-nantes',
      from: 'La Varenne',
      to: 'Nantes Centre',
      title: 'VTC La Varenne Nantes - Chauffeur Privé | Réservation Goloire-Cab au 02 59 22 20 00',
      metaDescription: 'Transfert VTC La Varenne ↔ Nantes Centre ⚡ Village viticole 🍷 Chauffeur privé ✓ Devis gratuit !',
      keywords: 'vtc la varenne nantes, transfert varenne nantes, taxi varenne nantes, chauffeur privé la varenne',
      heroImage: 'https://images.unsplash.com/photo-1449965408869-eaa3f722e40d?w=1920&q=80&fm=webp',
      distance: '25 km',
      duration: '30 min',
      price: 'Sur devis',
      priceReturn: 'Sur devis',
      fromCoords: { lat: 47.2978, lng: -1.2611 },
      toCoords: { lat: 47.2184, lng: -1.5536 },
      highlights: [
        'Vignoble - Nantes',
        'Desserte gare SNCF',
        'Proche Ancenis',
        'Service tous les jours'
      ],
      description: `VTC La Varenne vers Nantes Centre. Liaison confortable depuis ce village viticole vers le centre-ville et la gare SNCF.`,
      faq: [],
      category: 'loireEst'
    },
    
    // ORÉE D'ANJOU
    {
      slug: 'vtc-oree-d-anjou-aeroport',
      from: 'Orée d\'Anjou',
      to: 'Aéroport Nantes Atlantique',
      title: 'VTC Orée d\'Anjou Aéroport - Chauffeur Privé | Réservation Goloire-Cab au 02 59 22 20 00',
      metaDescription: 'Transfert VTC Orée d\'Anjou ↔ Aéroport Nantes Atlantique ⚡ Champtoceaux, Liré 🏛️ Chauffeur privé 24h/24 ✓ Devis gratuit !',
      keywords: 'vtc oree d anjou aeroport, transfert oree anjou aeroport, navette champtoceaux aeroport, taxi lire aeroport, joachim du bellay',
      heroImage: 'https://images.unsplash.com/photo-1436491865332-7a61a109cc05?w=1920&q=80&fm=webp',
      distance: '42 km',
      duration: '45 min',
      price: 'Sur devis',
      priceReturn: 'Sur devis',
      fromCoords: { lat: 47.3397, lng: -1.1783 },
      toCoords: { lat: 47.1531, lng: -1.6108 },
      highlights: [
        'Champtoceaux panorama Loire',
        'Maison Joachim du Bellay',
        'Portes de l\'Anjou',
        'Suivi des vols',
        'Service 24h/24',
        'Véhicules spacieux'
      ],
      description: `Transfert VTC depuis Orée d'Anjou (Champtoceaux, Liré, Drain) vers l'Aéroport Nantes Atlantique. Service premium aux portes de l'Anjou.`,
      faq: [
        {
          question: 'Desservez-vous toutes les communes d\'Orée d\'Anjou ?',
          answer: 'Oui, nous desservons Champtoceaux, Liré, Drain, Bouzillé et toutes les communes déléguées d\'Orée d\'Anjou.'
        }
      ],
      category: 'loireEst'
    },
    {
      slug: 'vtc-oree-d-anjou-nantes',
      from: 'Orée d\'Anjou',
      to: 'Nantes Centre',
      title: 'VTC Orée d\'Anjou Nantes - Chauffeur Privé | Réservation Goloire-Cab au 02 59 22 20 00',
      metaDescription: 'Transfert VTC Orée d\'Anjou ↔ Nantes Centre ⚡ Champtoceaux, Liré 🏛️ Chauffeur privé ✓ Devis gratuit !',
      keywords: 'vtc oree d anjou nantes, transfert oree anjou nantes, taxi champtoceaux nantes, chauffeur privé lire',
      heroImage: 'https://images.unsplash.com/photo-1449965408869-eaa3f722e40d?w=1920&q=80&fm=webp',
      distance: '35 km',
      duration: '40 min',
      price: 'Sur devis',
      priceReturn: 'Sur devis',
      fromCoords: { lat: 47.3397, lng: -1.1783 },
      toCoords: { lat: 47.2184, lng: -1.5536 },
      highlights: [
        'Anjou - Nantes',
        'Desserte gare SNCF',
        'Patrimoine Renaissance',
        'Service tous les jours'
      ],
      description: `VTC Orée d'Anjou vers Nantes Centre. Liaison depuis les portes de l'Anjou vers le centre-ville et la gare SNCF de Nantes.`,
      faq: [],
      category: 'loireEst'
    }
  ],

  // ===============================================
  // TRAJETS VERS GARE TGV SAINT-PIERRE-DES-CORPS (avril 2026)
  // Hub TGV Atlantique : Paris Montparnasse, Bordeaux, Lyon
  // ===============================================
  gareTGV: [
    {
      slug: 'vtc-nantes-saint-pierre-des-corps',
      from: 'Nantes',
      to: 'Gare TGV Saint-Pierre-des-Corps',
      title: 'VTC Nantes Gare TGV Saint-Pierre-des-Corps Tours | Goloire-Cab',
      metaDescription: 'VTC Nantes ↔ Gare TGV Saint-Pierre-des-Corps ⭐ 210 km, 2h 🚆 Correspondance TGV Atlantique ✓ Prix fixe dès 300€ ✓ Suivi TGV.',
      keywords: 'vtc nantes saint pierre des corps, vtc nantes gare tgv tours, transfert nantes tgv tours, chauffeur prive gare tgv tours',
      heroImage: 'https://images.unsplash.com/photo-1449965408869-eaa3f722e40d?w=1920&q=80&fm=webp',
      distance: '210 km', duration: '2h', price: 'dès 300€', priceReturn: 'dès 540€',
      fromCoords: { lat: 47.2184, lng: -1.5536 }, toCoords: { lat: 47.3919, lng: 0.7228 },
      highlights: [
        'Hub TGV Atlantique : Paris Montparnasse 55 min',
        'Correspondances Bordeaux, Lyon, Strasbourg',
        'Suivi TGV en temps réel',
        'Prise en charge Nantes centre, CHU, aéroport',
        'Service 24h/24 trains tôt matin & tard soir'
      ],
      description: `VTC Nantes vers Gare TGV Saint-Pierre-des-Corps (Tours). Liaison A11/A85 (210 km, 2h). Idéal lorsque votre TGV direct depuis Nantes n'est pas disponible ou pour rejoindre un train vers Bordeaux, Lyon, Strasbourg ou les correspondances internationales. Suivi de votre TGV en temps réel pour ajuster l'heure d'arrivée.`,
      faq: [
        { question: 'Prix VTC Nantes → Gare TGV Saint-Pierre-des-Corps ?', answer: 'Tarif fixe dès 300€ tout compris (210 km, 2h). Aller-retour 540€.' },
        { question: 'Pourquoi ne pas prendre le TGV direct ?', answer: 'Pour des horaires incompatibles, des correspondances vers Bordeaux/Lyon, ou des groupes privilégiant le porte-à-porte.' }
      ]
    },
    {
      slug: 'vtc-angers-saint-pierre-des-corps',
      from: 'Angers',
      to: 'Gare TGV Saint-Pierre-des-Corps',
      title: 'VTC Angers Gare TGV Saint-Pierre-des-Corps | Goloire-Cab',
      metaDescription: 'VTC Angers ↔ Gare TGV Saint-Pierre-des-Corps ⭐ 120 km, 1h20 🚆 Correspondance TGV Atlantique ✓ Prix fixe dès 175€ ✓ Suivi TGV.',
      keywords: 'vtc angers saint pierre des corps, vtc angers gare tgv tours, transfert angers tgv, chauffeur prive angers tgv',
      heroImage: 'https://images.unsplash.com/photo-1449965408869-eaa3f722e40d?w=1920&q=80&fm=webp',
      distance: '120 km', duration: '1h20', price: 'dès 175€', priceReturn: 'dès 310€',
      fromCoords: { lat: 47.4784, lng: -0.5632 }, toCoords: { lat: 47.3919, lng: 0.7228 },
      highlights: [
        'Autoroute A85 directe',
        'Hub TGV Atlantique Paris/Bordeaux/Lyon',
        'Prise en charge gare Angers Saint-Laud, hôtels',
        'Suivi TGV en temps réel',
        'Service 24h/24'
      ],
      description: `VTC Angers vers Gare TGV Saint-Pierre-des-Corps. Liaison A85 (120 km, 1h20). Idéal pour rejoindre les TGV Atlantique et correspondances internationales. Prise en charge Angers Saint-Laud, hôtels centre-ville, domaines viticoles AOC Anjou.`,
      faq: [
        { question: 'Prix VTC Angers → Gare TGV Saint-Pierre-des-Corps ?', answer: 'Tarif fixe dès 175€ (120 km, 1h20). Aller-retour 310€.' }
      ]
    },
    {
      slug: 'vtc-saumur-saint-pierre-des-corps',
      from: 'Saumur',
      to: 'Gare TGV Saint-Pierre-des-Corps',
      title: 'VTC Saumur Gare TGV Saint-Pierre-des-Corps | Goloire-Cab',
      metaDescription: 'VTC Saumur ↔ Gare TGV Saint-Pierre-des-Corps ⭐ 65 km, 50 min 🚆 Val de Loire ✓ Prix fixe dès 95€ ✓ Suivi TGV.',
      keywords: 'vtc saumur saint pierre des corps, vtc saumur gare tgv tours, transfert saumur tgv',
      heroImage: 'https://images.unsplash.com/photo-1449965408869-eaa3f722e40d?w=1920&q=80&fm=webp',
      distance: '65 km', duration: '50 min', price: 'dès 95€', priceReturn: 'dès 175€',
      fromCoords: { lat: 47.2598, lng: -0.0738 }, toCoords: { lat: 47.3919, lng: 0.7228 },
      highlights: [
        'A85 rapide Val de Loire',
        'Prise en charge château, domaines viticoles',
        'Hub TGV Atlantique',
        'Service touristes internationaux',
        'Suivi TGV inclus'
      ],
      description: `VTC Saumur vers Gare TGV Saint-Pierre-des-Corps. Liaison rapide A85 (65 km, 50 min). Parfait pour les visiteurs du château de Saumur, Cadre Noir et domaines viticoles AOC Saumur-Champigny souhaitant rejoindre un TGV Atlantique.`,
      faq: [
        { question: 'Prix VTC Saumur → Gare TGV Saint-Pierre-des-Corps ?', answer: 'Tarif fixe dès 95€ (65 km, 50 min). Aller-retour 175€.' }
      ]
    }
  ]
};

// Helper function to get all route pages as flat array
export const getAllRoutePages = () => {
  return [
    ...geoRoutePages.airport,
    ...geoRoutePages.nantes,
    ...geoRoutePages.puydufou,
    ...geoRoutePages.haluchere,
    ...geoRoutePages.loireEst,
    ...geoRoutePages.gareTGV,
    ...allAirportTransfers()
  ];
};

// Get route page by slug
export const getRoutePageBySlug = (slug) => {
  return getAllRoutePages().find(page => page.slug === slug) || getAirportTransferBySlug(slug);
};

export default geoRoutePages;
